define('viewmodels/Weightings_Thresholds/AMLInherentWeightings',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system'], function (ko, router, appsecurity, navigation, app, logger, system) {
    var title = 'AMLInherentWeightings';
    var checkWeighting = 0;
    var checkOverallWeighting = 0;
    var AIWViewModel = {
        cacheViews: false,
        activate: activate,
        title: title,
        attached: attached,
        detached: detached,
        appsecurity: appsecurity,
        RiskAreaList: ko.observableArray(),
        RiskFactorList: ko.observableArray(),
        BusinessUnitsList: ko.observableArray(),
        BusinessUnitsListIW: ko.observableArray(),
        RiskAreaListIW: ko.observableArray(),
        RiskFactorListIW: ko.observableArray(),
        WeightingsDataList: ko.observableArray(),
        WeightingsList: ko.observableArray(),
        PrevLevelDetailId: ko.observable(),
        PrevLevelDetailIdNumber: ko.observable(),
        RAWeightingsList: ko.observableArray(),
        ClickedRiskAreaId: ko.observable(),
        RAName: ko.observable(),
        saveWeightings: saveWeightings,
        saveValues: saveValues,
        copyData: copyData,
        RiskAreaTabClick: RiskAreaTabClick,
        ThemeId: ko.observable(),
        InputChange: InputChange,
        ClickedRiskAreaName: ko.observable(),
        PreviousId: ko.observable(),
        BusinessLevelsList: ko.observableArray(),
        ClickedLevelId: ko.observable(),
        ClickedLevelName: ko.observable(),
        ShowLevelsTab: ko.observable(),
        ShowDetailsTab: ko.observable(),
        PrevClickedRiskAreaTypeSubAreas: ko.observable(null),
        BusinessLevelDetailsList: ko.observableArray(),
        BusinessLevelTabClick: BusinessLevelTabClick,
        BusinessLevelOCFlag: ko.observable(false),
        BusinessLevelDetailTabClick: BusinessLevelDetailTabClick,
        ClickedLevelDetailId: ko.observable(),
        ClickedLevelDetailName: ko.observable(),
        LastClickedLevelDetailId: ko.observable(),
        BULWeightingsList: ko.observableArray(),
        BULOverallWeightingsList: ko.observableArray(),
        BusinessUnitsLowestLevelList: ko.observableArray(),
        WeightingsType: ko.observable(), //this specifies the type of the wightings. RA:Area|OA:Overall|BUL:business unit level|BULOverall :business unit level

        //To save weightings
        WeightingsListSave: ko.observableArray(),
        OverallWeightingsListSave: ko.observableArray(),
        BULWeightingsListSave: ko.observableArray(),
        BULOverallWeightingsListSave: ko.observableArray(),
        countEntry: ko.observable(0),
        ErrorStatus: ko.observable(0),
        countLevelEntry: ko.observable(0),
        LevelErrorStatus: ko.observable(0),
        RiskAreaTabClicked: ko.observable(),
        BuLevelDetailId: ko.observable(),
        InputChangeEvent: ko.observable(false),
        CopyDataButtonClicked: ko.observable(false),
        SaveButtonClick: ko.observable(false),
        LevelIdNumber: ko.observable(),
        AssessmentTypeList: ko.observableArray([]),
        SelectedAssessmentId: ko.observable(),
        AssessmentType:ko.observable(),
        AssessmentTypeId: ko.observable(),
        ScreenName: ko.observable(),
        SurveyCategoryList: ko.observableArray([]),
        SurveyCategoryTabClickIW: SurveyCategoryTabClickIW,
        SelectedSurveyComponentId: ko.observable(),
        RiskAreaTypeList: ko.observableArray([]),
        SubRiskAreaList: ko.observableArray([]),
        RiskSubAreaTabClick: RiskSubAreaTabClick,
        ClickedSubRiskAreaId: ko.observable(),
        ClickedSubRiskAreaName: ko.observable(),
        RiskFactorTabClick: RiskFactorTabClick,
        IsSideNavOpen: ko.observable(0),
        ISRAT: ko.observable(),
        SelectedType: ko.observable(),
        ClickedRiskAreaType: ko.observable(),
        RAId: ko.observable(),
        WeightingsBUDataList: ko.observableArray([]),
        WeightingsGridList: ko.observableArray([]),
        hasSubArea: ko.observable(),
        Parent_Id: ko.observable(),
        Type: ko.observable(),
        invokepage: invokepage,
        ComposeBindingFlag: ko.observable(false),
        ControlAreaList: ko.observableArray([]),
        AreaType: ko.observable(),
        AreaTypeFlag: ko.observable('F'),
    };

    return AIWViewModel;


    var GetAllRiskAreaAjax = {};
    var GetAllRiskFactorAjax = {};
    var GetRiskSubFactorAjax = {};
    var GetWeightingsAjax = {};
    var SaveWeightingsAjax = {};
    var GetOverAllWeightingsAjax = {};
    var GetBULevelWeightingsAjax = {};
    var GetBUlowestLevelsAjax = {};


    function activate() {
        try {
            var Id = AIWViewModel.appsecurity.getParameterByName('atype');
            AIWViewModel.AssessmentTypeId(Id);
            AIWViewModel.SelectedAssessmentId(Id);
            AIWViewModel.appsecurity.GetAssessmentNames().then(function () {

                AIWViewModel.AssessmentType(AIWViewModel.appsecurity.GetAssessmentName(AIWViewModel.SelectedAssessmentId()))
                AIWViewModel.ScreenName(AIWViewModel.AssessmentType() + ' Inherent Risk Weightings');
            })
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function detached() {
        try {
            $($(document.getElementsByClassName('list-group-item')).get(4)).removeClass('active');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function attached() {
        try {

            $('#WeightingsTableBU').hide();

            //commented start
            AIWViewModel.appsecurity.GetCurrentYearOfAssessment().then(function () {
                AIWViewModel.appsecurity.getYearOfAssessmentDetails().then(function () {
                    if (AIWViewModel.appsecurity.isConfigurationFreeze() == 1) {
                        AIWViewModel.appsecurity.WriteAccess(false);
                        // GetAllRiskAreas();
                    }
                    else {
                        // GetAllRiskAreas();
                    }

                })

                var parent = $(location).attr('href').split('/').pop();
                if (parent.split('?')[0] == 'AMLInherentWeightings') {
                    invokepage();
                    $("#SaveCopydiv").show();
                    $("#divIherentWeig").hide();
                    AIWViewModel.ComposeBindingFlag(false);
                } else {
                    
                    $("#SaveCopydiv").hide();
                    $("#SurveyCategoryTabClickIW").hide();
                    AIWViewModel.ComposeBindingFlag(true);
                    $("#divWeightings_BU").css({ 'margin-top': 'unset !important' });
                }

                AIWViewModel.countEntry(0);
                AIWViewModel.countLevelEntry(0);
                $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');

                //    GetAllRiskAreaAjax = {
                //        url: "/api/Configuration/GetAllRiskAreas",
                //        data: { "AssessmentType": AIWViewModel.SelectedAssessmentId(), "AreaType": "ALL" },
                //        type: "GET",
                //        headers: appsecurity.getSecurityHeaders()
                //    };

                    var options = {
                        url: "/api/WeightingsThresholds/GetAllBusinessUnits",
                        type: "GET",
                        headers: appsecurity.getSecurityHeaders()
                    };
                    getAllBusinessUnits(options);
                }
            );
            //comment end
            var url = window.location.pathname
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (filename == "AMLInherentWeightings") {
                $(document).on('change', 'input', function (e) {
                    GetTotalWeightings();
                    GetTotalWeightingsBUL();
                    GetTotalWeightingsBULOverall();
                });
            }
            $(document).on('keydown', 'input', function (e) {
                var url = window.location.pathname
                var filename = url.substring(url.lastIndexOf('/') + 1);
                var id = $(this).attr('id');
                var result = '', controlID = '', rows = 0;
                if ((id.substring(0, 14)) == "txt_weighting_") {
                    result = id.substring(("txt_weighting_").length, id.length);
                    controlID = 'txt_weighting_';
                    rows = AIWViewModel.RiskAreaListIW().length;
                    columns = AIWViewModel.BusinessUnitsListIW().length;
                }
                else if ((id.substring(0, 14)) == "txt_Oweighting") {
                    result = id.substring(("txt_Oweighting").length, id.length);
                    controlID = 'txt_Oweighting';
                    rows = AIWViewModel.RiskAreaList().length - 1// removing the Overall AML Inherent Weightings from the list;
                    columns = AIWViewModel.BusinessUnitsList().length;
                }
                else if ((id.substring(0, 21)) == "GetTotalWeightingsBUL") {
                    result = id.substring(("GetTotalWeightingsBUL").length, id.length);
                    controlID = 'GetTotalWeightingsBUL';
                    rows = AIWViewModel.BusinessUnitsLowestLevelList().length;
                    columns = AIWViewModel.RiskAreaList().length;
                } else if ((id.substring(0, 17)) == "txt_BULOweighting") {
                    result = id.substring(("txt_BULOweighting").length, id.length);
                    controlID = "txt_BULOweighting";
                    rows = AIWViewModel.RiskAreaList().length - 1;
                    columns = AIWViewModel.BusinessLevelDetailsList().length - 1;

                }


                if (e.which == 9 && filename == "AMLInherentWeightings" && rows > 1) {

                    var columnandrownuo = result.indexOf("_");

                    if (controlID == "txt_Oweighting") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.length));
                    }
                    else if (controlID == "txt_weighting_") {
                        var columnno = Number(result.substring(0, columnandrownuo));
                        var rowno = Number(result.substring(columnandrownuo + 1, result.length));

                    }
                    else if (controlID == "GetTotalWeightingsBUL") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));

                    }
                    else if (controlID == "txt_BULOweighting") {
                        var rowno = Number(result.substring(0, columnandrownuo));
                        var columnno = Number(result.substring(columnandrownuo + 1, result.lastIndexOf("_")));
                    }
                    var lineno = 0;
                    for (var l = 0; l < AIWViewModel.RiskAreaListIW().length - 1; l++) {
                        if (AIWViewModel.RiskAreaListIW()[l].RiskAreaId() == rowno) {
                            rowno = AIWViewModel.RiskAreaListIW()[l + 1].RiskAreaId();
                            break;
                        }
                   
                        if (l + 2 == rows) {
                            lineno = rows;  //15 was added
                        }         

                    }

           

     
                //    AIWViewModel.RiskFactorList[rowno]().Id;
                   // rowno = rowno + 1;
                   //rowno =  AIWViewModel.RiskFactorList[rowno]().Id;
                    if (lineno == rows) {
                       // rowno = 0;
                      //  rowno = AIWViewModel.RiskFactorList()[columnno + 1].RiskFactorId();
                        for (var k = 0; k < AIWViewModel.BusinessUnitsListIW().length - 1; k++) {
                            if (AIWViewModel.BusinessUnitsListIW()[k].BusinessUnit_ID() == columnno) {
                                columnno = AIWViewModel.BusinessUnitsListIW()[k + 1].BusinessUnit_ID();
                                rowno = AIWViewModel.RiskAreaListIW()[0].RiskAreaId();
                                break;
                            }
                        }
                        //columnno = columnno + 1;
                    }
                    for (var i = columnno; i < columns; i++) {
                        if (controlID == "txt_Oweighting") {
                            var tobefocusedid = controlID + rowno + "_" + columnno;
                        } else if (controlID == "txt_weighting_") {
                            var tobefocusedid = controlID + columnno + "_" + rowno;
                        }
                        else if (controlID == "GetTotalWeightingsBUL") {
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + AIWViewModel.ClickedLevelDetailId()
                        }
                        else if (controlID == "txt_BULOweighting") {
                            var tobefocusedid = controlID + rowno + "_" + columnno + "_" + AIWViewModel.ClickedLevelDetailId()
                        }
                        if ($("#" + tobefocusedid).prop('disabled')) {
                            columnno = columnno + 1;
                        }
                        else {
                            break;
                        }
                    }
                                                                if (columns == columnno | columnandrownuo == -1 | isNaN(rowno)) {
                         //do nothing to make tab work as per its functionality
                     }
                     else if (controlID == "txt_Oweighting") {
                         e.preventDefault();
                         var tobefocusedid = controlID + rowno + "_" + columnno;
                          $("#" + tobefocusedid).focus();
                         $("#" + tobefocusedid).select();

                     } else if (controlID == "txt_weighting_") {
                         e.preventDefault();
                     var tobefocusedid = controlID + columnno + "_" + rowno;
                         if ($("#" + tobefocusedid).prop('disabled')) {

                         }
                         else {
                              $("#" + tobefocusedid).focus();
                               $("#" + tobefocusedid).select();
                         }
                     }
                     else if (controlID == "GetTotalWeightingsBUL") {
                         e.preventDefault();
                         var tobefocusedid = controlID + rowno + "_" + columnno + "_" + AIWViewModel.ClickedLevelDetailId()
                           $("#" + tobefocusedid).focus();
                          $("#" + tobefocusedid).select();
                     }
                     else if (controlID == "txt_BULOweighting") {
                         e.preventDefault();
                         var tobefocusedid = controlID + rowno + "_" + columnno + "_" + AIWViewModel.ClickedLevelDetailId()
                          $("#" + tobefocusedid).focus();
                          $("#" + tobefocusedid).select();
                     }


                }
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }


    function InputChange() {
        AIWViewModel.InputChangeEvent(true);
       
            $(this).next('.input').focus();
        
    }

    function invokepage() {
        try {
            if (AIWViewModel.ComposeBindingFlag()) {
                $("#SaveCopydiv").hide();
                $("#NoComponentDataDivIW").hide();
                $("#divIherentWeig").show();
                $("#WeightingsBtnQuan").show();
            }
            GetSurveyCategoryTabs();
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: invokepage() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }



    function RiskSubAreaTabClick(data, event) {
        try {


            if (AIWViewModel.appsecurity.WriteAccess() == false || AIWViewModel.appsecurity.WriteAccess() == "false") {
                AIWViewModel.countLevelEntry(0);
            }
           
            if (AIWViewModel.countLevelEntry() == 0) {
                AIWViewModel.countLevelEntry(1);
                AIWViewModel.RiskAreaTabClicked(false);
                $('#loadingMainImgDivIWAMLRA_Levels_OverALL').show();
                AIWViewModel.SelectedType('QUAL');


                $('#WeightingsBtnQuan').show();
                //AIWViewModel.RAId(data.RiskAreaId());
                //AIWViewModel.RAName(data.RiskAreaName());
                $("#lblErrorAMLControls").hide();
                AIWViewModel.ClickedRiskAreaType('QUAL');
                //AIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
                //AIWViewModel.ClickedRiskAreaName(data.RiskAreaName());
                AIWViewModel.ClickedSubRiskAreaId(data.RiskAreaId());
                AIWViewModel.ClickedSubRiskAreaName(data.RiskAreaName());
                AIWViewModel.AreaTypeFlag(data.AreaType());
                if (data.AreaType() == 'O') {
                    AIWViewModel.PrevClickedRiskAreaTypeSubAreas(data.AreaType());
                    GetOverAllSubAreas();
                } else {
                    AIWViewModel.PrevClickedRiskAreaTypeSubAreas('F');
                    GetAllRiskFactors();
                    }
                }
            
            else if ((AIWViewModel.InputChangeEvent() || AIWViewModel.CopyDataButtonClicked()) && AIWViewModel.SaveButtonClick() == false) {
                AIWViewModel.InputChangeEvent(false);
                AIWViewModel.CopyDataButtonClicked(false);

                app.showMessage("Please save the data before moving to other tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Save") {
                            saveWeightings();

                            if (AIWViewModel.ErrorStatus() == 1) {
                                AIWViewModel.ErrorStatus(0);
                              //  $('#' + AIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
                               // $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');data.RiskAreaId()
                                if (AIWViewModel.PrevClickedRiskAreaTypeSubAreas() == 'O') {
                                    $('#' + data.RiskAreaId() + "_S" + data.AreaType()).removeClass('ui-tabs-active ui-state-active');
                                    $('#' + AIWViewModel.RAId() + "_S" + AIWViewModel.PrevClickedRiskAreaTypeSubAreas()).addClass('ui-tabs-active ui-state-active');
                                }
                                else {
                                    $('#' + AIWViewModel.RAId() + "_S" + data.AreaType()).removeClass('ui-tabs-active ui-state-active');
                                    $('#' + data.RiskAreaId() + "_S" + AIWViewModel.PrevClickedRiskAreaTypeSubAreas()).addClass('ui-tabs-active ui-state-active');
                                  
                                }
                              
                                AIWViewModel.SaveButtonClick(false);
                            }
                            else {
                                AIWViewModel.SaveButtonClick(false);
                                AIWViewModel.countLevelEntry(0);
                              
                                $('#' + AIWViewModel.RAId() + "_S" + AIWViewModel.PrevClickedRiskAreaTypeSubAreas()).removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId() + "_S" + data.AreaType()).addClass('ui-tabs-active ui-state-active');
                                RiskSubAreaTabClick(data, event);
                                //    }
                                //}
                            }
                        }
                        else {
                            AIWViewModel.countLevelEntry(0);
                            $('#' + AIWViewModel.RAId() + "_S" + AIWViewModel.PrevClickedRiskAreaTypeSubAreas()).removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.RiskAreaId() + "_S" + data.AreaType()).addClass('ui-tabs-active ui-state-active');
                            RiskSubAreaTabClick(data, event);
                        }
                    });
            }
            else {
                AIWViewModel.SaveButtonClick(false);
                AIWViewModel.countLevelEntry(0);
                $('#' + AIWViewModel.RAId() + "_SA").removeClass('ui-tabs-active ui-state-active');
                $('#' + data.RiskAreaId() + "_SA").addClass('ui-tabs-active ui-state-active');
                RiskSubAreaTabClick(data, event);
            }
    
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubAreaTabClick() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function GetOverAllSubAreas(previousFlag) {
        try {
            AIWViewModel.LastClickedLevelDetailId(previousFlag);
           
            GetBUlevelWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetBULevelWeightings",
                data: { "RiskAreaType": AIWViewModel.SelectedAssessmentId(), "DeUid": 0, "ParentAreaId": AIWViewModel.RAId(), "Zat_Uid": AIWViewModel.SelectedSurveyComponentId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlevelWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {

                    AIWViewModel.RiskAreaListIW([]);
                    var mappedControlAreas = $.map(jsonResult.AreasList, function (result) {
                        return new RiskAreas(result);
                    });
                    AIWViewModel.RiskAreaListIW(mappedControlAreas);

                    AIWViewModel.BusinessUnitsListIW([]);
                    var MappedBUModelList = $.map(jsonResult.BUList, function (result) {
                        return new BusinessUnitModel(result);
                    });
                    AIWViewModel.BusinessUnitsListIW(MappedBUModelList);

                    if ($.fn.DataTable.isDataTable('#WeightingsTable1')) {
                        var tableObj = $('#WeightingsTable1').DataTable();
                        tableObj.fixedHeader.disable();
                        tableObj.destroy();
                        $('#WeightingsTable1 tbody tr').remove();
                        $("#trOneW > th").remove();
                        $("#trTwoW > th").remove();
                        var htmlHeaders = "";

                        htmlHeaders += '<th class="" style=""><span class="glyphicon glyphicon-arrow-down"></span>Risk Areas  / <span class="glyphicon glyphicon-arrow-right"></span>Business Units</th>'
                        for (var i = 0; i < AIWViewModel.BusinessUnitsListIW().length; i++) {
                            htmlHeaders += '<th style="text-align:left;vertical-align:middle;" title="' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '" class="noSort" data-bind="text: ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + ', attr:{id: ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + ', \'title\': ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '}, css:{\'long header-ellipsis\': true}">' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + '</th>'
                        }
                        $("#trOneW").append(htmlHeaders);

                        var htmlHeaders1 = "";
                        htmlHeaders1 += '<th class="noSort" style="border-bottom: unset !important;font-weight:700;text-align: left;vertical-align:middle;background-color:#00a3e0;">Total</th>'
                        for (var i = 0; i < AIWViewModel.BusinessUnitsListIW().length; i++) {
                            htmlHeaders1 += '<th class="noSort" style="text-align:center;vertical-align:middle;background-color:white;border: 1px solid #ccc !important;">'
                            htmlHeaders1 += '<div class="input-group" style="text-align:center;vertical-align:middle;">'
                            htmlHeaders1 += '<input type="text" disabled style="font-weight: 600;position:unset !important;background-color:#cccccc;" class="form-control inputWBU" id="txt_weighting_' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + '" }">'
                            htmlHeaders1 += '<span class="input-group-addon">%</span>'
                            htmlHeaders1 += ' </div>'
                            htmlHeaders1 += '</th>'
                        }
                        $("#trTwoW").append(htmlHeaders1);

                    }
                    var mappedWeightings = $.map(jsonResult.WeightingsDataList, function (result) {
                        return new WeightingDataModel(result);
                    });
                    AIWViewModel.WeightingsDataList(mappedWeightings);

                    $('#loadingMainControlsDiv').hide();

                    $('#WeightingsTableBU').show();

                    var scrollHeight = "30rem";

                    if (AIWViewModel.ComposeBindingFlag()) {
                        scrollHeight = "25rem";
                    }

                    var oTable = $('#WeightingsTable1').DataTable(
                        {
                            'aoColumnDefs': [{
                                'bSortable': false,
                                "targets": "_all"
                               // 'aTargets': ['noSort']
                            }],
                            "aaSorting": [],
                            scrollY: scrollHeight,
                            scrollX: true,
                            scrollCollapse: true,
                            fixedColumns: true,
                            paging: false,
                            "bInfo": false,
                            "bAutoWidth": false,
                            fixedColumns: {
                                leftColumns: 1
                            },
                            fixedheader: {
                                header: true
                            },
                        });

                    $('#WeightingsTable1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");

                    GetTotalWeightings();

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskAreaId = ko.observable($('<div/>').html(item.RiskAreaId).text());
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.BuId = ko.observable($('<div/>').html(item.BuId).text());
            self.Bu_Name = ko.observable($('<div/>').html(item.Bu_Name).text());
            self.WeightingValue = ko.observable($('<div/>').html(item.WeightingValue).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }


    function BUCountListModel(item) {
        try {
            var self = this;
            var MappedObject = $.map(item.ResponseList, function (result) {
                return new RiskLevelModel(result);
            });
            self.ResponseList = MappedObject;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function SurveyCategoryTabClickIW(data, event) {
        try {

            $('#loadingMainImgDivIW').show();

         
            $("#lblErrorAMLControls").hide();
            
            AIWViewModel.SelectedSurveyComponentId(data.SurveyCategoryId());
            AIWViewModel.RiskAreaList([]);
            
            if (data.SurveyCategoryId() === -999)
                GetAllRiskLevels(data.SurveyCategoryId());
            else
                GetAllRiskAreasForCategories();
            $('#loadingMainImgDivIW').hide();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClickIW() method in AMLWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskAreasForCategories() {
        try {

            $.ajax({
                url: "/api/Configuration/GetAllRiskAreas",
                data: {
                    "AreaType": "NULL", "ParentAreaId": "NULL", "TypeId": "NULL",
                    "SurveyCategoryID": AIWViewModel.SelectedSurveyComponentId(), "AssessmentTypes": AIWViewModel.AssessmentTypeId(),
                    "ScreenType": 'IWX'
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskAreas() method in AMLWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null && jsonResult[0].RiskAreaName != null) {
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        return new RiskAreaModel(result);
                    });
                    AIWViewModel.RiskAreaList(mappedRiskAreaList);
                   // AIWViewModel.RiskAreaTypeList(mappedRiskAreaList);
                 
                    //AMLRaViewModel.countEntry(0);
                    $('#RaTab_IW').tabs();
                    $('#RaTab_IW').tabs('refresh');
                    $('#RaTab_IW').tabs({ active: 0 });
                    $($('#RiskAreaUl_IW li').get(0)).trigger('click');
                }
                else if (jsonResult[0].RiskAreaName == null)
                    app.showMessage("Risk Areas are not yet configured for this year of assessment. Please configure the Risk Areas to before setting Thresholds", "Error in Fetching Risk Areas", ["OK"])
                        .then(function (option) {
                            if (option == "OK")
                                router.navigate("configuration/RisksAreasfactors", true);
                        })
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in AMLWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLWeightings.js';
                logger.logMessage(msg);
            }
        };
    }




    function GetSurveyCategoryTabs() {
        try {
            $.ajax({
                url: "/api/Configuration/GetSurveyCategoryTabsByAssessmentType",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "AssessmentId": AIWViewModel.AssessmentTypeId(), "ScreenType": "IWX" }
            })
                .success(function (jsonResult, success) {
                    try {
                        if (jsonResult != null) {
                            var mappedTabList = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            $('#loadingMainImgDivIW').show();
                            AIWViewModel.SurveyCategoryList(mappedTabList);
                            $('#SurveyCategoryTab_IW').tabs();
                            $('#SurveyCategoryTab_IW').tabs('refresh');
                            $('#SurveyCategoryTab_IW').tabs({ active: 0 });
                            $($('#SurveyCategoryTab_IW li').get(0)).trigger('click');
                            scrollableTabs();
                        }
                        else {
                            $('#loadingMainImgDivIW').hide();
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }

                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in AMLThresholds.js';
                        logger.logMessage(msg);
                    }

                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in AMLThresholds.js';
            logger.logMessage(msg);
        }
    }


    //function to pull all the assessment types starts here

    function GetTotalWeightings() {

        try {
            var url = window.location.pathname;
            $('#lblErrorAMLControls').hide();
            
            var filename = url.substring(url.lastIndexOf('/') + 1);
            if (AIWViewModel.ClickedRiskAreaId() == "AML_OVERALL") {
                //if (AIWViewModel.RAId() == "AML_OVERALL") {

                for (var k = 0; k < AIWViewModel.BusinessUnitsList().length; k++) {
                    var sum = parseFloat(0);
                    for (var i = 0; i < AIWViewModel.RiskAreaList().length - 1; i++) {

                        var x = "#txt_Oweighting" + i + "_" + k;
                        sum = parseFloat(sum) + parseFloat($(x).val());
                    }

                    //changed  RAID TO ClickedRiskAreaId

                    var rowcount = k;
                    if (isNaN(sum)) {
                        $("#txt_Oweighting" + rowcount + AIWViewModel.ClickedRiskAreaId()).val(0);
                    } else {
                        $("#txt_Oweighting" + rowcount + AIWViewModel.ClickedRiskAreaId()).val(parseFloat(sum).toFixed(2));
                    }
                    if (sum.toFixed(2) == 100.00) {
                        $("#txt_Oweighting" + rowcount + AIWViewModel.ClickedRiskAreaId()).css('color', '#000000')
                        $("#txt_Oweighting" + rowcount + AIWViewModel.ClickedRiskAreaId()).css("background-color", "#cccccc")
                    } else {
                        $("#txt_Oweighting" + rowcount + AIWViewModel.ClickedRiskAreaId()).css('color', 'red')

                    }
                }
          //      $("#divWeightings_BU").show();
               // $("#WeightingsTableBU").show();
            } else {
                for (var k = 0; k < AIWViewModel.BusinessUnitsListIW().length; k++) {
                    var sum = parseFloat(0);
                    for (var i = 0; i < AIWViewModel.RiskAreaListIW().length; i++) {
                        var x = "#txt_weighting_" + AIWViewModel.BusinessUnitsListIW()[k].BusinessUnit_ID() + "_" + AIWViewModel.RiskAreaListIW()[i].RiskAreaId();
                     
                        //   var x = "#txt_weighting" + i + "_" + k + "_" + AIWViewModel.RAId();
                        sum = parseFloat(sum) + parseFloat($(x).val());
                    }
                    var colcount = AIWViewModel.BusinessUnitsListIW()[k].BusinessUnit_ID();
                 //   var rowcount = k;
                    if (isNaN(sum)) {
                        $("#txt_weighting_" + colcount).val(0);
                    } else {
                        $("#txt_weighting_" + colcount).val(parseFloat(sum).toFixed(2));
                    }
                    if (sum.toFixed(2) == 100.00) {
                        $("#txt_weighting_" + colcount).css('color', '#000000');
                        $("#txt_weighting_" + colcount).css("background-color", "#cccccc");
                    } else {
                        $("#txt_weighting_" + colcount).css('color', 'red');

                    }
                }
                $('#loadingMainImgDivIWAMLRA_Levels_OverALL').hide();
                $('#loadingImgOrCalc_IW').hide();
                $('#loadingMainInherentDiv').hide();
                
             //   $("#divWeightings_BU").show();
               // $("#WeightingsTableBU").show();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetTotalWeightings() method in AmlInherentWeightings.js';
            logger.logMessage(msg);
        }

    }
    function GetTotalWeightingsBUL() {

        var url = window.location.pathname;
       
        var filename = url.substring(url.lastIndexOf('/') + 1);
        
        for (var k = 1; k <= AIWViewModel.RiskAreaList().length; k++) {

            var sum = parseFloat(0);
            for (var i = 0; i < AIWViewModel.BusinessUnitsLowestLevelList().length; i++) {

                var x = "#GetTotalWeightingsBUL" + i + "_" + k + "_" + AIWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k - 1;
            if (isNaN(sum)) {
                $("#GetTotalWeightingsBUL" + rowcount + AIWViewModel.ClickedLevelDetailId()).val(0);
            } else {
                $("#GetTotalWeightingsBUL" + rowcount + AIWViewModel.ClickedLevelDetailId()).val(sum);
            }

            if (sum.toFixed(2) == 100.00) {
                $("#GetTotalWeightingsBUL" + rowcount + AIWViewModel.ClickedLevelDetailId()).css('color', '#000000')
                $("#GetTotalWeightingsBUL" + rowcount + AIWViewModel.ClickedLevelDetailId()).css("background-color", "#cccccc")
            } else {
                $("#GetTotalWeightingsBUL" + rowcount + AIWViewModel.ClickedLevelDetailId()).css('color', 'red')

            }
        }

        $('#loadingMainInherentDiv').hide();
        $('#lblErrorAMLControls').hide();
        $('#loadingMainImgDivIWAMLRA_Levels_OverALL').hide();
        $('#loadingImgOrCalc_IW').hide();

    }
    function GetTotalWeightingsBULOverall() {

        var url = window.location.pathname;
        var filename = url.substring(url.lastIndexOf('/') + 1);

        for (var k = 0; k <= AIWViewModel.BusinessLevelDetailsList().length - 1; k++) { //-1 as the last item of the list is overall tab

            var sum = parseFloat(0);
            for (var i = 0; i < AIWViewModel.RiskAreaList().length - 1; i++) {

                var x = "#txt_BULOweighting" + i + "_" + k + "_" + AIWViewModel.ClickedLevelDetailId();
                sum = parseFloat(sum) + parseFloat($(x).val());
            }
            var rowcount = k;
            if (isNaN(sum)) {
                $("#txt_BULOweighting" + rowcount + AIWViewModel.ClickedLevelDetailId()).val(0);
            } else {
                $("#txt_BULOweighting" + rowcount + AIWViewModel.ClickedLevelDetailId()).val(sum);
            }
            if (sum.toFixed(2) == 100.00) {
                $("#txt_BULOweighting" + rowcount + AIWViewModel.ClickedLevelDetailId()).css('color', '#000000')
                $("#txt_BULOweighting" + rowcount + AIWViewModel.ClickedLevelDetailId()).css("background-color", "cccccc")
            } else {
                $("#txt_BULOweighting" + rowcount + AIWViewModel.ClickedLevelDetailId()).css('color', 'red')

            }
        }
        $('#loadingMainInherentDiv').hide();
        $('#lblErrorAMLControls').hide();
        $('#loadingMainImgDivIWAMLRA_Levels_OverALL').hide();
        $('#loadingImgOrCalc_IW').hide();
    }
    //----------------------------------------------------------------RiskFactorTabClick Starts here-------------------------------------------------------------
    function RiskFactorTabClick(data, event) {
        try {
            $('#RiskLevelDataTab').hide();
            AIWViewModel.countEntry(false)
            AIWViewModel.ClickedRiskFactor(data.RiskFactorId());
            AIWViewModel.ClickedRiskFactorName(data.RiskFactorName());
            $('#RiskLevelTabinnerDiv_IW').empty();
            $('#RiskLevelinnerTabDivforheatmnaps_IW').empty();
          
            if (AIWViewModel.ClickedRiskFactor() == "AMLINH-OVE-" + AIWViewModel.ClickedRiskAreaId()) {
                AIWViewModel.IsOverall(1);
                AIWViewModel.Type('A');
                //CreateOverAllTabHTML();
                $("#FactorReportDownload").hide();
                $("#RiskLevelDataTab").hide();
                $("#ThresholdsBtn").hide();
            }
            else {
                $("#ThresholdsBtn").show();
                $("#FactorReportDownload").show();
                AIWViewModel.IsOverall(0);
                AIWViewModel.Type('F');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in RiskFactorTabClick() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function getAllBusinessUnits(options) {
        try {
            $.ajax(options)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnits() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {
                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnits(result);
                    });
                    AIWViewModel.BusinessUnitsList(mappedBusinessUnits);
                }
                else {
                    //app.showMessage("Business Units configurations not in place", "Error", ["OK"]);
                    $("#NobusinessUnitserror").show();
                    $("#RaTab_IW").hide();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnits() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    };
    function getAllBusinessUnitlowestLevels(entityId) {
        try {
            GetBUlowestLevelsAjax = {
                url: "/api/Configuration/getAllLowestLevelUnitsByLevels",
                data: { "entityId": entityId, "asst_type": AIWViewModel.SelectedAssessmentId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlowestLevelsAjax)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in getAllBusinessUnitlowestLevels() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResultObj, status) {

            try {
                if (jsonResultObj != 'undefined' && jsonResultObj != null && jsonResultObj != "") {
                    var mappedBusinessUnits = $.map(jsonResultObj, function (result) {
                        return new BusinessUnits(result);
                    });
                    AIWViewModel.BusinessUnitsLowestLevelList([]);

                    AIWViewModel.BusinessUnitsLowestLevelList(mappedBusinessUnits);
                    GetBUlevelWeightings();

                }
                else {
                    $('#outerdiv').hide();
                    for (var i = 0; i < AIWViewModel.RiskAreaList().length; i++) {
                        $('#AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).hide();
                    }
                    //app.showMessage("Business Units configurations not in place", "Error", ["OK"]);
                    $("#lblAMLError").show();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getAllBusinessUnitlowestLevels() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }

        };
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getAllBusinessUnits() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in getAllBusinessUnits() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    }
    function GetAllRiskAreas() {
        try {
            var Type = null;
            if (AIWViewModel.SelectedType().toLowerCase() == 'RAT') {
                Type = AIWViewModel.SelectedAreaType();
            }


            $.ajax({
                url: "/api/Configuration/GetAllRiskAreas",
                data: {
                    "AreaType": "NULL", "ParentAreaId": "NULL", "TypeId": "NULL",
                    "SurveyCategoryID": AIWViewModel.SelectedSurveyComponentId(), "AssessmentTypes": AIWViewModel.AssessmentTypeId(),
                    "ScreenType": 'IWX'
                },
            //    data: { "AssessmentType": AIWViewModel.SelectedAssessmentId(), "AreaType": "ALL", "TypeId": null },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskAreas() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "" && jsonResult[0].RiskAreaName != null) {
                   //if (AIWViewModel.AssessmentType() == "AML")
                       jsonResult[jsonResult.length] = { RiskAreaId: "AML_OVERALL", RiskAreaName: "Overall " + AIWViewModel.AssessmentType() + " Inherent Weightings", RiskAreaType: "AML", RiskAreaNameSort: "Overall " + AIWViewModel.AssessmentType() + " Inherent Weightings" }
                    //else
                    //    jsonResult[jsonResult.length] = { RiskAreaId: "AML_OVERALL", RiskAreaName: "Overall Sanctions Inherent Weightings", RiskAreaType: "SANC" }
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        addNewDivTab(RiskAreaModelObj);
                        return RiskAreaModelObj;
                    });
                    AIWViewModel.RiskAreaList(mappedRiskAreaList);
                    $('#RaTab_IW').tabs();
                    $('#RaTab_IW').tabs('refresh');
                    $('#RaTab_IW').tabs({ active: 0 });
                    $($('#RiskAreaUl_IW li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else {
                    app.showMessage("Risk Area configurations not in place.", "Error", ["OK"]);
                    $("#NoAreasserror").show();
                    $('#RaTab_IW').hide();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskAreas() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        };

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        };
    }
    function GetAllRiskLevels(RiskAreaID) {
        try {

            $.ajax({
                url: "/api/Configuration/getAllBusinessUnitLevels",
                data: { "type": AIWViewModel.SelectedAssessmentId(), "Page_Type": "IW" },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllRiskLevels() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null && jsonResult[0].BuLevelName != null) {
                    $('#loadingMainInherentDiv').show();
                    var mappedBULevelsList = $.map(jsonResult, function (result) {
                        return new BusinessLevelModel(result);
                    });
                    AIWViewModel.BusinessLevelsList(mappedBULevelsList);
                    AIWViewModel.ShowLevelsTab(true);
                    var max = AIWViewModel.BusinessLevelsList()[0].LevelID();
                    var id = AIWViewModel.BusinessLevelsList()[0].LevelID()
                    for (i = 0; i < AIWViewModel.BusinessLevelsList().length; i++) {
                        if (max < AIWViewModel.BusinessLevelsList()[i].LevelID()) {
                            max = AIWViewModel.BusinessLevelsList()[0].LevelID();
                        }
                    }
                    //for (i = 0; i < AIWViewModel.BusinessLevelsList().length; i++) {
                    //    if (max == AIWViewModel.BusinessLevelsList()[i].LevelID()) {
                    //        AIWViewModel.BusinessLevelsList()[i].LevelID('LevelOverall');
                    //    }
                    //}
                    $('#RfTab_IWO').tabs();
                    $('#RfTab_IWO').tabs('refresh');
                    $('#RfTab_IWO').tabs({ active: 0 });
                    $($('#RfTab_IWO li').get(0)).trigger('click');
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AIWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskLevels() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskLevels() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskLevels() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    };
    function GetRiskLevelDetails(LevelID, LevelName) {
        try {

            $.ajax({
                url: "/api/WeightingsThresholds/getBusinessUnitLevelDetails",
                data: { "levelid": LevelID },
                type: "GET",
                async: false,
                headers: appsecurity.getSecurityHeaders()
            })
        .success(ajaxSuccess)
        .fail(ajaxFail);



        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetRiskLevelDetails() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if (jsonResult.length != 0) {
                        $('#RiskLevelDetailsTabDiv').show();
                        $('#RiskLevelDetailsTabDiv').removeClass('alert-warning');
                    jsonResult[jsonResult.length] = { BuLevelDetailId: LevelID + "OVERALL", BuLevelDetailName: LevelName + "-OVERALL" }
                    var mappedBULevelsList = $.map(jsonResult, function (result) {
                        return new BusinessLevelDetail(result);
                    });
                    AIWViewModel.BusinessLevelDetailsList(mappedBULevelsList);

                    //$('#RdTab').tabs();
                    //$('#RdTab').tabs('refresh');
                    //$('#RdTab').tabs({ active: 0 });
                    //$($('#RiskLevelDetailUl li').get(0)).trigger('click');
                }
                    else {
                        AIWViewModel.BusinessLevelDetailsList([]);
                        $('#RiskLevelDetailsTabDiv').empty();
                        $('#RiskLevelDetailsTabDiv').addClass('alert-warning')
                    }
                }
                else
                    logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AIWViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskLevelDetails() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskLevelDetails() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskLevelDetails() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    };
    //functions to add divs
    function addNewDivTab(data) {
        try {
            $('#RiskAreaTabDiv').append(
          '<div id="AMLTabDiv-' + data.RiskAreaId() + '" style="overflow:hidden;"></div>');


            $('#QualTab_IW').append(
                '<div id="AMLTabDiv-' + data.RiskAreaId() + '" style="overflow:hidden;"></div>');

        
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTab() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function addNewDivTabBULevel(BuDetailId) {
        try {
            $('#RiskLevelDetailsTabDiv').empty();
            $('#RiskLevelDetailsTabDiv').append(
          '<div id="AMLTabDiv-' + BuDetailId + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTabBULevel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function addNewDivTabBULevelOverall(AreaId) {
        try {
            $('#RiskLevelTabDiv_IW').append(
          '<div id="AMLTabDiv-' + AreaId + '" style="overflow:hidden;"></div>');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: addNewDivTabBULevel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetAllRiskFactors() {
        try {

            $.ajax({
                url: "/api/WeightingsThresholds/GetAllRiskfactorAreaWise",
                //data: { "RiskAreaId": AIWViewModel.RAId(), "AssessmentType": AIWViewModel.SelectedAssessmentId() }, 
                data: { "RiskAreaId": AIWViewModel.ClickedSubRiskAreaId(), "AssessmentType": AIWViewModel.SelectedAssessmentId(), "SurveyCategoryId": AIWViewModel.SelectedSurveyComponentId() },
                    
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
           .success(ajaxSuccess1)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetAllRiskFactors() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess1(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null) {
                    if (jsonResult[0].Flag == 1) {

                        var mappedRiskFactors = $.map(jsonResult, function (result) {
                            return new RiskFactorModel(result);
                        });
                        AIWViewModel.RiskFactorList([]);
                        AIWViewModel.RiskFactorList(mappedRiskFactors);
                        $('#NoFactorserror').hide();
                        //$('#RiskAreaTabDiv').show();
                        GetWeightingsAjax = {
                          
                            url: "/api/WeightingsThresholds/GetAllRiskAreaWeightings",
                            data: { "RiskAreaId": AIWViewModel.ClickedSubRiskAreaId(), "RiskAreaType": AIWViewModel.SelectedAssessmentId(),"SurveyCategoryId": AIWViewModel.SelectedSurveyComponentId() },
                            type: "GET",
                            headers: appsecurity.getSecurityHeaders()
                        };
                        GetWeightings(GetWeightingsAjax);
                    }
                    else {
                        app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);
                        $('#NoFactorserror').show();
                        $('#RiskAreaTabDiv').hide();
                        $('#QualTab_IW').hide();
                        
                    }
                } else {
                    $('#NoFactorserror').show();
                    $('#RiskAreaTabDiv').hide();
                    $('#QualTab_IW').hide();
                    app.showMessage("Risk Factors are not configured for this Risk Area.", "Error", ["OK"]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllRiskFactor() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskFactor() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskFactor() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetWeightings(GetWeightingsAjax) {
        try {
            $('#WeightingsTableBU').hide();
            $.ajax(GetWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    
                    AIWViewModel.RiskAreaListIW([]);
                    var mappedControlAreas = $.map(jsonResult.AreasList, function (result) {
                        return new RiskAreas(result);
                    });
                    AIWViewModel.RiskAreaListIW(mappedControlAreas);
                    $('#lblErrorAMLControls').hide();
                    AIWViewModel.BusinessUnitsListIW([]);
                    var MappedBUModelList = $.map(jsonResult.BUList, function (result) {
                        return new BusinessUnitModel(result);
                    });
                    AIWViewModel.BusinessUnitsListIW(MappedBUModelList);

                    if ($.fn.DataTable.isDataTable('#WeightingsTable1')) {
                        var tableObj = $('#WeightingsTable1').DataTable();
                        tableObj.fixedHeader.disable();
                        tableObj.destroy();
                        $('#WeightingsTable1 tbody tr').remove();
                        $("#trOneW > th").remove();
                        $("#trTwoW > th").remove();
                        var htmlHeaders = "";

                        htmlHeaders += '<th class="" style=""><span class="glyphicon glyphicon-arrow-down"></span>Risk Areas  / <span class="glyphicon glyphicon-arrow-right"></span>Business Units</th>'
                        for (var i = 0; i < AIWViewModel.BusinessUnitsListIW().length; i++) {
                            htmlHeaders += '<th style="text-align:left;vertical-align:middle;" title="' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '" class="noSort" data-bind="text: ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + ', attr:{id: ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + ', \'title\': ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '}, css:{\'long header-ellipsis\': true}">' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + '</th>'
                        }
                        $("#trOneW").append(htmlHeaders);

                        var htmlHeaders1 = "";
                        htmlHeaders1 += '<th class="noSort" style="border-bottom: unset !important;font-weight:700;text-align: left;vertical-align:middle;background-color:#00a3e0;">Total</th>'
                        for (var i = 0; i < AIWViewModel.BusinessUnitsListIW().length; i++) {
                            htmlHeaders1 += '<th class="noSort" style="text-align:center;vertical-align:middle;background-color:white;border: 1px solid #ccc !important;">'
                            htmlHeaders1 += '<div class="input-group" style="text-align:center;vertical-align:middle;">'
                            htmlHeaders1 += '<input type="text" disabled style="font-weight: 600;position:unset !important;background-color:#cccccc;" class="form-control inputWBU" id="txt_weighting_' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + '" }">'
                            htmlHeaders1 += '<span class="input-group-addon">%</span>'
                            htmlHeaders1 += ' </div>'
                            htmlHeaders1 += '</th>'
                        }
                        $("#trTwoW").append(htmlHeaders1);

                    }
                    var mappedWeightings = $.map(jsonResult.WeightingsDataList, function (result) {
                        return new WeightingDataModel(result);
                    });
                    AIWViewModel.WeightingsDataList(mappedWeightings);

                    $('#loadingMainControlsDiv').hide();
                   
                    $('#WeightingsTableBU').show();
                   
                    var scrollHeight = "30rem";

                    if (AIWViewModel.ComposeBindingFlag()) {
                        scrollHeight = "25rem";
                    }

                    var oTable = $('#WeightingsTable1').DataTable(
                        {
                            'aoColumnDefs': [{
                                'bSortable': false,
                                "targets": "_all"
                                //'aTargets': ['noSort']
                            }],
                            "aaSorting": [],
                            scrollY: scrollHeight,
                            scrollX: true,
                            scrollCollapse: true,
                            fixedColumns: true,
                            paging: false,
                            "bInfo": false,
                            "bAutoWidth": false,
                            fixedColumns: {
                                leftColumns: 1
                            },
                            fixedheader: {
                                header: true
                            },
                        });

                    $('#WeightingsTable1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");

                    GetTotalWeightings();

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajaxSuccess in GetWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

    }


    function WeightingDataModel(item) {
        try {
            var self = this;
            self.RiskAreaId = ko.observable($('<div/>').html(item.RiskAreaId).text());
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());

            var MappedObject = $.map(item.BusinessUnitCountList, function (result) {
                return new BUCountListModel(result);
            });
            self.BusinessUnitCountList = MappedObject;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }

    function BusinessUnitModel(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuLId);
            var BuName = item.BuLevelName;
            if (item.BuLevelName.length > 17) {
                BuLevelName = item.BuLevelName.substring(0, 17) + '...';
            } else {
                var space = item.BuLevelName.length;
                var spaceText = '';
                for (j = 0; j < 20 - space; j++) {
                    spaceText += '&nbsp';
                }
                BuLevelName = item.BuLevelName + spaceText;
            }
            self.BusinessUnit_NameTitle = ko.observable($('<div/>').html(item.BuLevelName).text());
            self.BusinessUnit_Name = ko.observable($('<div/>').html(BuLevelName).text());
            self.SortOrder = ko.observable($('<div/>').html(item.SortOrder).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in AMLControlsWeightings.js';
            logger.logMessage(msg);
        }
    }


    function WeightingsTable(checkWeighting) {
        try {
            var selectedRow, selectedCol;
            var j = AIWViewModel.BusinessUnitsList().length;
            var rows = AIWViewModel.RiskFactorList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < AIWViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucolumnheight = tdHeight / 2;
            $('#outerdiv').show();
            //for (var i = 0; i < AIWViewModel.RiskAreaList().length; i++) {
            //    $('#AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).show();
            //}
            //for (var i = 0; i < AIWViewModel.RiskAreaList().length; i++) {
            //    document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            //}
            var TabData =
                       '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (AIWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnAMLInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnAMLCopy-' + AIWViewModel.RAId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnAMLSave-' + AIWViewModel.RAId() + '" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-2 col-lg-1 control-label no-padding control-label-key">Risk Area Name : </label>' +
                      '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label fnormal control-label-val">' + AIWViewModel.RAName() + '</label>' +
                      '</div><label id="lblAMLError-' + AIWViewModel.RAId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                '<label id="lblAMLError" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none">No Data Available.</label>';
                //             '<label id="lblAMLError" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none">No Data Available.</label>' +

            MapWeightingsBUDataList(checkWeighting);
           // //Corner cell
           // '<div class="wclscscroll corner-header">' +
           //     '<table style="width:100%">' +
           //           '<tr>' +
           //                                  '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Name</th>' +
                     

           //          '</tr>' +
           //          '<tr>' +
           //           '<th class="site_name label-info headcol-min1 text-center" title="Risk Factor Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Factor Name</th>' +
           //           '</tr>' +
           //        '</table>' +
           //   '</div>' +
           // //Corner cell end


           ////Header Business units
           //         '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + AIWViewModel.RAId() + '" style="width:65%;">' +
           //             '<table>' +
           //                 '<tr>'
           // for (var i = 0 ; i < j; i++) {


           //     TabData += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '</th>';

            AIWViewModel.PreviousId(AIWViewModel.RAId());
            document.getElementById('AMLTabDiv-' + AIWViewModel.RAId()).innerHTML = "";
            document.getElementById('AMLTabDiv-' + AIWViewModel.RAId()).innerHTML = TabData;
            ko.applyBindingsToNode($('#btnAMLSave-' + AIWViewModel.RAId()), { click: AIWViewModel.saveWeightings }, AIWViewModel);
            ko.applyBindingsToNode($('#btnAMLCopy-' + AIWViewModel.RAId()), { click: AIWViewModel.copyData }, AIWViewModel);

         


            ImplementWeightingTableSecurity();
            $('#loadingMainImgDivIWAMLRA_Levels_OverALL').hide();
         
            $('#loadingMainImgDivIWAMLRA_IW').hide();
            $('#RiskAreaTabDiv').show();
            $('#QualTab_IW').show();
            $('#divWeightings_BU').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }     
                }
           // TabData += '</tr>' +

           //            '</table>' +
           //           '</div>' +

           ////Header Business units end

           // //Row headers
           //              '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + AIWViewModel.RAId() + '" style="width:100%">' +
           //                  '<table>';
           // for (var i = 0; i < rows; i++) {
           //     var factText = AIWViewModel.RiskFactorList()[i].RiskFactorName();
           //     var length = parseInt(factText.length);
           //     var colHeight = parseInt((Math.ceil(length / 40)));
           //     colHeight = colHeight + 4;
                

                //TabData += '<tr><td class="tbl-weightings-cell Weightingsheader" style="min-height:42px;height:' + colHeight + 'em !important;">';
                //        TabData += factText;
                //TabData += '</td></tr>';

    function MapWeightingsBUDataList(checkWeighting) {
        try {
         
            AIWViewModel.WeightingsGridList([]);
            if ($.fn.DataTable.isDataTable('#WeightingsTable1')) {
                tableObj = $('#WeightingsTable1').DataTable();
                tableObj.destroy();
                $('#WeightingsTable1 tbody tr').remove();

            }

          
            //TabData += '</table></div>' +
            ////Row headers end




            //           //Data 
            //             '<div class="wclscscroll table-content" id="clscroll-content' + AIWViewModel.RAId() + '" style="width:65%;">' +
            //'<table id="tblAMLWeightings-' + AIWViewModel.RAId() + '" ><tbody>';
      
            //for (var i = 0; i < rows; i++) {
            //    TabData += '<tr id="' + AIWViewModel.RiskFactorList()[i].RiskFactorId() + '">';
            //    var factText = AIWViewModel.RiskFactorList()[i].RiskFactorName();
            //    var length = parseInt(factText.length);
            //    var colHeight = parseInt((Math.ceil(length / 40)));
            //    colHeight = colHeight + 4;
            //    for (var k = 0; k < (j) ; k++) {
            //        if (AIWViewModel.appsecurity.WriteAccess() == false) {

            //            TabData += '<td id=" ' + AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" class=" disabled tbl-weightings-cell long weightingspadding" style="height:' + colHeight + 'em !important;"><div class="input-group">';

                    //}
                    //else {
                    //    TabData += '<td id=" ' + AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" class="tbl-weightings-cell long weightingspadding" style="height:' + colHeight + 'em !important;"><div class="input-group">';
                    //}
                    //selectedCol = AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
            for (var i = 0; i < AIWViewModel.RiskFactorList().length; i++) {
                for (var k = 0; k < AIWViewModel.BusinessUnitsList().length; k++) {

                        if (checkWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < AIWViewModel.WeightingsList().length; val++) {
                            if (AIWViewModel.WeightingsList()[val].BuId() == AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && AIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {

                                var newObj = new WeightingModel({ 'Id': AIWViewModel.RiskFactorList()[i].RiskFactorId(), 'Name': AIWViewModel.RiskFactorList()[i].RiskFactorName(), 'BuId': AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID(), 'WeightingValue': 0, 'BuStatus': AIWViewModel.BusinessUnitsList()[k].BuStatus() });
                         
                                AIWViewModel.WeightingsGridList().push(newObj);                                        // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                //AIWViewModel.WeightingsList().push(newObj);
                                 //   TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                                check_new = false;
                                break;
                                }
                            else if (AIWViewModel.WeightingsList()[val].Id() == AIWViewModel.RiskFactorList()[i].RiskFactorId() && AIWViewModel.WeightingsList()[val].BuId() == AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {

                            var newObj = new WeightingModel({ 'Id': AIWViewModel.RiskFactorList()[i].RiskFactorId(), 'Name': AIWViewModel.RiskFactorList()[i].RiskFactorName(), 'BuId': AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID(), 'WeightingValue': AIWViewModel.WeightingsList()[val].WeightingValue(), 'BuStatus': AIWViewModel.BusinessUnitsList()[k].BuStatus() });
                         
                                AIWViewModel.WeightingsGridList().push(newObj);
                                 //   TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="' + AIWViewModel.WeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {
                               var newObj = new WeightingModel({ 'Id': AIWViewModel.RiskFactorList()[i].RiskFactorId(), 'Name': AIWViewModel.RiskFactorList()[i].RiskFactorName(), 'BuId': AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID(), 'WeightingValue': 0, 'BuStatus': AIWViewModel.BusinessUnitsList()[k].BuStatus() });
                         
                                AIWViewModel.WeightingsGridList().push(newObj);
                            //if (AIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                            //        var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            //        AIWViewModel.WeightingsList().push(newObj);
                            //        TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            //    }
                            //    else {
                            //        var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            //        AIWViewModel.WeightingsList().push(newObj);
                            //        TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            //    }
                                }
                        //} else {
                        //if (AIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                        //    var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                        //        AIWViewModel.WeightingsList().push(newObj);
                        //        TabData += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                        else {
                            var newObj = new WeightingModel({ 'Id': AIWViewModel.RiskFactorList()[i].RiskFactorId(), 'Name': AIWViewModel.RiskFactorList()[i].RiskFactorName(), 'BuId': AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID(), 'WeightingValue': 0, 'BuStatus': AIWViewModel.BusinessUnitsList()[k].BuStatus() });
                         
                            AIWViewModel.WeightingsGridList().push(newObj);
                            //    var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            //    AIWViewModel.WeightingsList().push(newObj);
                            //    TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            //}
                          }

                      //  TabData += '</div></td>';


                }
                //TabData += '</tr>';
            }

            var mappedList = ko.observableArray();
            for (var i = 0; i < AIWViewModel.RiskFactorList().length; i++) {
                var weightingsData = ko.utils.arrayFilter(AIWViewModel.WeightingsGridList(), function (parameter) {
                    if (parameter.Id() == AIWViewModel.RiskFactorList()[i].RiskFactorId())
                        return true;
                    else
                        return false;
                });


//            TabData += '</tbody></table></div>';
//            //Total  cell

//            TabData += '<div class="wclscscroll corner-header">' +
//                '<table>' +
//           '<tr>';
            
//            TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
//            TabData += "Total"
//            TabData += '</td>' +

//            '</tr>' +

//         '</table>' +
//    '</div>' +
////Total cell end  
//            //Total Data
//            '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + AIWViewModel.RAId() + '">' +
//                 '<table>' +
//                     '<tr>'
//            for (var m = 0; m < AIWViewModel.BusinessUnitsList().length; m++) {
//                TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
//                TabData += '<input type="text" disabled style="background-color: #cccccc;"  class="form-control form-controlWT" id="' + 'txt_weighting' + m + AIWViewModel.RAId() + '"></input><span class="input-group-addon">%</span>';
//                TabData += '</td>';
                mappedList.push(new BUModel({ 'RiskFactorId': weightingsData[0].Id(), 'RiskFactorName': weightingsData[0].Name(), 'rowData': weightingsData }));          
                //ko.applyBindingsToNode($('#txt_weighting-' + m + AIWViewModel.RAId()), { event: { keyup: AIWViewModel.InputChange } }, AIWViewModel);
            }
            //TabData += '</tr>' +
            //'</table></div>'; 
            ////Total Dataend

            //document.getElementById('AMLTabDiv-' + AIWViewModel.RAId()).innerHTML = TabData;
            //ko.applyBindingsToNode($('#btnAMLSave-' + AIWViewModel.RAId()), { click: AIWViewModel.saveWeightings }, AIWViewModel);
            //ko.applyBindingsToNode($('#btnAMLCopy-' + AIWViewModel.RAId()), { click: AIWViewModel.copyData }, AIWViewModel);


            //for (var i = 0; i < rows; i++) {
            //    for (var k = 0; k < (j + 1) ; k++) {

            //        ko.applyBindingsToNode($('#txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId()), { event: { keyup: AIWViewModel.InputChange } }, AIWViewModel);

            //    }
            //}

            //ImplementWeightingTableSecurity();
            //$("#clscroll-content" + AIWViewModel.RAId()).scroll(function () {
            //    $("#clscroll-row-headers" + AIWViewModel.RAId()).scrollTop($("#clscroll-content" + AIWViewModel.RAId()).scrollTop());
            //    $("#clscroll-column-headers" + AIWViewModel.RAId()).scrollLeft($("#clscroll-content" + AIWViewModel.RAId()).scrollLeft());
            //    $("#clscroll-column-footer" + AIWViewModel.RAId()).scrollLeft($("#clscroll-content" + AIWViewModel.RAId()).scrollLeft());
            //});

            //$("#clscroll-column-headers" + AIWViewModel.RAId()).scroll(function () {
            //    $("#clscroll-content" + AIWViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + AIWViewModel.RAId()).scrollLeft());
            //});

            //$("#clscroll-column-footer" + AIWViewModel.RAId()).scroll(function () {
            //    $("#clscroll-content" + AIWViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + AIWViewModel.RAId()).scrollLeft());
            //});

            //$("#clscroll-row-headers" + AIWViewModel.RAId()).scroll(function () {
            //    $("#clscroll-content" + AIWViewModel.RAId()).scrollTop($("#clscroll-row-headers" + AIWViewModel.RAId()).scrollTop());
            //});
            //$('#loadingMainImgDivIWAMLRA_IW').hide();
            ////$('#RiskAreaTabDiv').show();
            //$('#QualTab_IW').show();
            AIWViewModel.WeightingsBUDataList([]);
            AIWViewModel.WeightingsBUDataList(mappedList());

            var a = AIWViewModel.BusinessUnitsList();

          //  $('#divWeightings_BU').show();
            //$('#divControlsWeightings_SBU').hide();
            if ($.fn.dataTable.isDataTable('#WeightingsTable1')) {
                $('#WeightingsTable1').DataTable().destroy();
            } 
            var oTable = $('#WeightingsTable1').DataTable(
                {
                    "bSort": false,
                    scrollY: "38rem",
                    scrollX: true,
                    scrollCollapse: true,
                    "bAutoWidth": false,
                    bFilter: false,
                    paging: false,
                    "bInfo": false,
                   
                    fixedHeader: {
                        header: true
                    },
                    fixedColumns: {
                        leftColumns: 1
                    }
                });

       $('#WeightingsTable1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");
            GetTotalWeightings();
         

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementWeightingTableSecurity() {
        try {
            if (AIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody').find('input').length; i++) {
                    $($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementWeightingTableSecurity() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    //function InputChange() {
    //    AIWViewModel.InputChangeEvent(true);
    //}

    function GetOverallWeightings() {
        try {
            GetOverAllWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetOverallWeightings?RiskAreaType=" + AIWViewModel.SelectedAssessmentId() + "&Type=A",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetOverAllWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetOverallWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkOverallWeighting = 1;
                    AIWViewModel.RAWeightingsList([]);
                    AIWViewModel.RAWeightingsList(mappedWeightings);
                    OverallWeightingsTable(checkOverallWeighting);
                    GetTotalWeightings();
                }
                else {
                    checkOverallWeighting = 0;
                    OverallWeightingsTable(checkOverallWeighting);
                    GetTotalWeightings();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetOverallWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverallWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOverallWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }


    }
    function OverallWeightingsTable(checkOverallWeighting) {
        try {
            var selectedRow, selectedCol;
            var rows = AIWViewModel.RiskAreaList().length - 1;
            var j = AIWViewModel.BusinessUnitsList().length;
            var buHeight;
            var tdHeight;
            for (var i = 0; i < AIWViewModel.BusinessUnitsList().length; i++) {
                colHeight = Math.ceil(AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucolumnheight = tdHeight / 2;
            //for (var i = 0; i <= AIWViewModel.RiskAreaList().length; i++) {
            //    document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
            //}

            var TabDataOverAll = '</br>' +
                        '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (AIWViewModel.appsecurity.WriteAccess()) {
                TabDataOverAll += '<span id="spnAMLInherent" class="pull-right">' +

                   '<button type="button" class="btn btn-primary btn-sm" id="btnAMLCopyOverall" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +

                           '<i class="fa fa-copy"></i>Copy to All' +
                       '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnAMLSaveOverall" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                    '<i class="fa fa-check"></i>Save' +
                       '</button></span>';
            }
            

            TabDataOverAll += '<label  style="padding-left:1em" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label control-label-border">Overall Inherent Weightings</label>' +
           '</div><label id="lblAMLError-' + AIWViewModel.RAId() + '" class="control-label alert alert-danger col-xs-12 col-sm-12 col-md-12 col-lg-12 alerts-inherent" style="display:none"></label>' +
                       //Corner cell
            '<div class="wclscscroll corner-header">' +
                '<table style="width:100%">' +
                      '<tr>' +
                                             '<th class="site_name label-info headcol-min1 text-center" title="Business Unit Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Name</th>' +


                     '</tr>' +
                     '<tr>' +
                      '<th class="site_name label-info headcol-min1 text-center" title="Risk Area Name" style="height:' + bucolumnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Area Name</th>' +
                      '</tr>' +
                   '</table>' +
              '</div>' +
            //Corner cell end
            //Header Business units
                    '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + AIWViewModel.RAId() + '" style="width:65%;">' +
                        '<table>' +
                            '<tr>'
            for (var i = 0 ; i < j; i++) {


                TabDataOverAll += '<th style=height:' + tdHeight + 'em !important;" class="site_name long label-info" id="' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_ID() + '" title="' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '">' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '</th>';

                }
            TabDataOverAll += '</tr>' +

                       '</table>' +
                      '</div>' +

           //Header Business units end
                       //Row headers
                         '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + AIWViewModel.RAId() + '" style="width:100%">' +
                             '<table>';
            for (var i = 0; i < rows; i++) {
                var factText = AIWViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;


                TabDataOverAll += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                TabDataOverAll += AIWViewModel.RiskAreaList()[i].RiskAreaNameConcat();
                TabDataOverAll += '</td></tr>'
            }
            TabDataOverAll += '</table></div>' +
            //Row headers end
                                   //Data 
                         '<div class="wclscscroll table-content" id="clscroll-content' + AIWViewModel.RAId() + '" style="width:65%;">' +
            '<table  id="tblAMLWeightingsOverall"><tbody>';
            for (var i = 0; i < rows; i++) {
                var factText = AIWViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;
                selectedRow = AIWViewModel.RiskAreaList()[i].RiskAreaId();
                TabDataOverAll += '<tr id="' + AIWViewModel.RiskAreaList()[i].RiskAreaId() + '">';
                for (var k = 0; k < (j) ; k++) {
                    // TabDataOverAll += '<td class="tbl-weightings-cell">';
                    if (AIWViewModel.appsecurity.WriteAccess() == false) {
                        TabDataOverAll += '<td id="' + AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="disabled tbl-weightings-cell long weightingspadding"><div class="input-group">';
                    }
                    else {
                        TabDataOverAll += '<td id="' + AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() + '" style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';

                    }
                    selectedCol = AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID();
                        if (checkOverallWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < AIWViewModel.RAWeightingsList().length; val++) {
                                if (AIWViewModel.RAWeightingsList()[val].BuId() == AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID() && AIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                    // var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue' : 0 });
                                    //AIWViewModel.WeightingsList().push(newObj);
                                    TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                                else if (AIWViewModel.RAWeightingsList()[val].Id() == AIWViewModel.RiskAreaList()[i].RiskAreaId() && AIWViewModel.RAWeightingsList()[val].BuId() == AIWViewModel.BusinessUnitsList()[k].BusinessUnit_ID()) {
                                    TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '"value="' + AIWViewModel.RAWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {
                                if (AIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                    var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                    AIWViewModel.RAWeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '" value="0"></input><span class="input-group-addon">%</span>';
                                }
                                else {
                                    var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                    AIWViewModel.RAWeightingsList().push(newObj);
                                    TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '"value="0"></input><span class="input-group-addon">%</span>';
                                }
                                }
                        } else {
                            if (AIWViewModel.BusinessUnitsList()[k].BuStatus() == 'NOT APPLICABLE') {
                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                AIWViewModel.RAWeightingsList().push(newObj);
                                TabDataOverAll += '<input type="text" disabled style="background-color: #cccccc;" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_weighting' + i + '_' + k + '_' + AIWViewModel.RAId() + '" value="0"></input><span class="input-group-addon">%</span>';
                            }
                            else {



                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            AIWViewModel.RAWeightingsList().push(newObj);
                            TabDataOverAll += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_Oweighting' + i + '_' + k + '"value="0"></input><span class="input-group-addon">%</span>';
                        }
                            }
                        TabDataOverAll += '</div></td>';
                    }
                
                TabDataOverAll += '</tr>';
                //if (i == rows - 1) {


                // }



            }


            TabDataOverAll += '</tbody></table></div>';
            //totalheader table
            //Total  cell

            TabDataOverAll += '<div class="wclscscroll corner-header">' +
                '<table>' +
           '<tr>';

            TabDataOverAll += '<td   style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
            TabDataOverAll += "Total"
            TabDataOverAll += '</td>' +

            '</tr>' +

         '</table>' +
    '</div>' +
//Total cell end  
            //Total Data
            '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + AIWViewModel.RAId() + '">' +
                 '<table>' +
                     '<tr>'
            for (var i = 0; i < AIWViewModel.BusinessUnitsList().length; i++) {
                TabDataOverAll += '<td style="height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                TabDataOverAll += '<input type="text" disabled style="background-color:#cccccc"class="form-control form-controlWT" id="' + 'txt_Oweighting' + i + AIWViewModel.RAId() + '"></input><span class="input-group-addon">%</span>';
                TabDataOverAll += '</td>';
            }
            TabDataOverAll += '</tr>' +
            '</table></div>';
            //Total Dataend
            //end of toatl table 

            document.getElementById('AMLTabDiv-' + AIWViewModel.RAId()).innerHTML = TabDataOverAll;
            ko.applyBindingsToNode($('#btnAMLSaveOverall'), { click: AIWViewModel.saveWeightings }, AIWViewModel);
            ko.applyBindingsToNode($('#btnAMLCopyOverall'), { click: AIWViewModel.copyData }, AIWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {
                    ko.applyBindingsToNode($('#txt_Oweighting' + i + '_' + k), { event: { keyup: AIWViewModel.InputChange } }, AIWViewModel);
                }
            }
            //for (var i = 0; i < AIWViewModel.BusinessUnitsList().length; i++) {
            //    ko.applyBindingsToNode($('#txt_Oweighting' + i + AIWViewModel.RAId()), { event: { keyup: AIWViewModel.InputChange } }, AIWViewModel);
            //}
            ImplementOverallTableSecurity();
            $("#clscroll-content" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-row-headers" + AIWViewModel.RAId()).scrollTop($("#clscroll-content" + AIWViewModel.RAId()).scrollTop());
                $("#clscroll-column-headers" + AIWViewModel.RAId()).scrollLeft($("#clscroll-content" + AIWViewModel.RAId()).scrollLeft());
                $("#clscroll-column-footer" + AIWViewModel.RAId()).scrollLeft($("#clscroll-content" + AIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-headers" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + AIWViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + AIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-footer" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + AIWViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + AIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-row-headers" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + AIWViewModel.RAId()).scrollTop($("#clscroll-row-headers" + AIWViewModel.RAId()).scrollTop());
            });
            $('#loadingMainImgDivIWAMLRA_IW').hide();
            $('#loadingMainImgDivIWAMLRA_Levels_OverALL').hide();
       //     $('#RiskAreaTabDiv').show();
            $('#QualTab_IW').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallWeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementOverallTableSecurity() {
        try {
            if (AIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblAMLWeightingsOverall tbody').find('input').length; i++) {
                    $($('#tblAMLWeightingsOverall tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OverallWeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    //Functions to build the list for save/update
    function buildSaveWeightingsList() {
        if (AIWViewModel.WeightingsType() == 'RA') {
            buildSaveRAWeightingsList();
        }
        else if (AIWViewModel.WeightingsType() == 'OC') {
            buildSaveOverallWeightingsList();
        }
        //else if (AIWViewModel.WeightingsType() == 'BULOverall') {
        //    buildSaveBULOverallWeightingsList();
        //}
        //else if (AIWViewModel.WeightingsType() == 'BUL') {
        //    buildSaveBULWeightingsList();
        //}
    }
    function buildSaveRAWeightingsList() {
        try {
            AIWViewModel.WeightingsListSave([]);
            var rows = AIWViewModel.RiskAreaListIW().length;
            var cols = AIWViewModel.BusinessUnitsListIW().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weighting_' + AIWViewModel.BusinessUnitsListIW()[j].BusinessUnit_ID() + '_' + AIWViewModel.RiskAreaListIW()[i].RiskAreaId();
               
                 //   var txtid = '#txt_weighting' + i + '_' + j + '_' + AIWViewModel.RAId();
                    var newObj = new WeightingModel({
                        'Id': AIWViewModel.RiskAreaListIW()[i].RiskAreaId(), 'BuId': AIWViewModel.BusinessUnitsList()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    AIWViewModel.WeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function buildSaveOverallWeightingsList() {
        try {
            AIWViewModel.OverallWeightingsListSave([]);
            var rows = AIWViewModel.RiskAreaListIW().length;
            var cols = AIWViewModel.BusinessUnitsListIW().length;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_weighting_' + AIWViewModel.BusinessUnitsListIW()[j].BusinessUnit_ID() + '_' + AIWViewModel.RiskAreaListIW()[i].RiskAreaId();
                    var newObj = new WeightingModel({
                        'Id': AIWViewModel.RiskAreaListIW()[i].RiskAreaId(), 'BuId': AIWViewModel.BusinessUnitsListIW()[j].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    AIWViewModel.OverallWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function buildSaveBULWeightingsList() {
        try {
            AIWViewModel.BULWeightingsListSave([]);
            var rows = AIWViewModel.BusinessUnitsLowestLevelList().length;
            var cols = AIWViewModel.RiskAreaList().length - 1;
            for (i = 0; i < rows; i++) {
                for (j = 1; j <= cols; j++) {
                    var txtid = '#GetTotalWeightingsBUL' + i + '_' + j + '_' + AIWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': AIWViewModel.RiskAreaList()[j - 1].RiskAreaId(), 'BuId': AIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID(),
                        'WeightingValue': $(txtid).val()
                    });
                    AIWViewModel.BULWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveBULWeightingsList() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function buildSaveBULOverallWeightingsList() {
        try {
            AIWViewModel.BULOverallWeightingsListSave([]);
            var rows = AIWViewModel.RiskAreaList().length - 1;
            var cols = AIWViewModel.BusinessLevelDetailsList().length - 1;
            for (i = 0; i < rows; i++) {
                for (j = 0; j < cols; j++) {
                    var txtid = '#txt_BULOweighting' + i + '_' + j + '_' + AIWViewModel.ClickedLevelDetailId();
                    var newObj = new WeightingModel({
                        'Id': AIWViewModel.RiskAreaList()[i].RiskAreaId(), 'BuId': AIWViewModel.BusinessLevelDetailsList()[j].DetailId(),
                        'WeightingValue': $(txtid).val()
                    });
                    AIWViewModel.BULOverallWeightingsListSave().push(newObj);
                }

            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: buildSaveWeightingsList() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }


    }
    function copyDataRA() {
        try {
            var cols = AIWViewModel.BusinessUnitsListIW().length;
            $("#lblAMLError-" + AIWViewModel.RAId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeightingsValue = [];
            var weightingsvaluearray = [];
            if (AIWViewModel.RAId() != "AML_OVERALL") {
                rows = AIWViewModel.RiskAreaListIW().length;
            } else {
                rows = AIWViewModel.RiskAreaListIW().length - 1;
            }

            for (var k = 0; k < AIWViewModel.BusinessUnitsListIW().length; k++) {
                if (k == 0) {
                    for (var i = 0; i < AIWViewModel.RiskAreaListIW().length; i++) {
                        if (AIWViewModel.RAId() != "AML_OVERALL") {
                            var txtValue = $("#txt_weighting_" + AIWViewModel.BusinessUnitsListIW()[k].BusinessUnit_ID() + "_" + AIWViewModel.RiskAreaListIW()[i].RiskAreaId()).val();
                        }
                        else {
                            var txtValue = $($('#tblAMLWeightingsOverall tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                        }


                        if (txtValue == "") {

                            $("#lblAMLError-" + AIWViewModel.RAId()).show();
                            $("#lblAMLError-" + AIWViewModel.RAId()).text('Cell cannot be left blank.');
                            valid = 1;
                            break;
                        }
                        else {
                            var txt = parseFloat(txtValue);
                            if (!$.isNumeric(txt)) {
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('Non-numeric entry is not allowed.');
                                valid = 1;
                                break;
                            }
                            else if (txt < 0 || txt > 100) {
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('Value should be in range of (0-100).');
                                valid = 1;
                                break;
                            }
                            else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('Decimal upto 2 places is allowed');
                                valid = 1;
                                break;
                            }
                            else {
                                weightingsvaluearray.push(txt);
                                sum += txt;
                            }
                        }
                    }
                }
            }
            if (valid == 1) {
                AIWViewModel.ErrorStatus(1);
                $('#loadingMainImgDivIWAMLRA_IW').hide();
                $('#RiskAreaTabDiv').show();
                $('#QualTab_IW').show();
            }
            if (valid == 0) {
                if (AIWViewModel.RAId() != "AML_OVERALL") {
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = AIWViewModel.RiskAreaListIW()[i].RiskAreaId();
                        for (var j = 0; j < cols; j++) {
                            selectedColId = AIWViewModel.BusinessUnitsListIW()[j].BusinessUnit_ID();
                            for (var k = 0; k < AIWViewModel.WeightingsDataList().length; k++) {
                                if (selectedRowId == AIWViewModel.WeightingsDataList()[k].RiskAreaId()) {
                                    var buList = AIWViewModel.WeightingsDataList()[k].BusinessUnitCountList;
                                    for (var m = 0; m < buList.length; m++) {
                                        var weightingNode = buList[m];
                                        if (selectedColId == weightingNode.ResponseList[0].BuId() && selectedRowId == weightingNode.ResponseList[0].RiskAreaId()) {
                                            weightingNode.ResponseList[0].WeightingValue(weightingsvaluearray[i]);
                                        }
                                    }
                                }
                            }
                        }
                    }
                 //   WeightingsTable(1);
                   GetTotalWeightings();
                }
                else {
                    AIWViewModel.RAWeightingsList()
                    AIWViewModel.RAWeightingsList([]);
                    for (var i = 0; i < rows; i++) {
                        selectedRowId = AIWViewModel.RiskAreaList()[i].RiskAreaId();
                        for (var j = 0; j < cols; j++) {

                            selectedColId = AIWViewModel.BusinessUnitsList()[j].BusinessUnit_ID();
                            wValue = WeightingsValue[i];
                            var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                            AIWViewModel.RAWeightingsList.push(newObj);
                        }
                    }
                    $('#tblAMLWeightingsOverall').remove();
                    OverallWeightingsTable(1);
                 //   GetTotalWeightings();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyDataBUL() {
        try {
            var cols = AIWViewModel.RiskAreaList().length - 1;
            $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            var WeightingsValue = [];
            rows = AIWViewModel.BusinessUnitsLowestLevelList().length;

            for (var i = 0; i < rows; i++) {
                var txtValue = $($('#tblAMLWeightingsBU-' + AIWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(1).firstChild.firstChild.value;
                if (txtValue == "") {
                    $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                    $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed');
                        valid = 1;
                        break;
                    }
                    else {
                        WeightingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                AIWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {

                AIWViewModel.BULWeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = AIWViewModel.BusinessUnitsLowestLevelList()[i].DetailId();
                    for (var j = 0; j < cols; j++) {

                        selectedColId = AIWViewModel.RiskAreaList()[i].RiskAreaId();
                        wValue = WeightingsValue[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        AIWViewModel.BULWeightingsList.push(newObj);
                    }
                }
                $('#tblAMLWeightingsBU-' + AIWViewModel.ClickedLevelDetailId()).remove();
                BULevelWeightingsTable(1);
                GetTotalWeightingsBUL();
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataRA() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyDataBULOverall() {
        try {
            var cols = AIWViewModel.BusinessLevelDetailsList().length - 1;
            $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).hide();
            var valid = 0;
            var selectedRowId = 0;
            var selectedColId = 0;
            var wValue = 0;
            var sum = 0;
            var rows;
            rows = AIWViewModel.RiskAreaList().length - 1;
            var WeightingsValue = [];
            for (var i = 0; i < rows; i++) {
                var txtValue = $($('#tblAMLOverallWeightingsBUL-' + AIWViewModel.ClickedLevelDetailId() + ' tbody tr').get(i)).find('td').get(0).firstChild.firstChild.value;
                if (txtValue == "") {
                    $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                    $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Cell cannot be left blank.');
                    valid = 1;
                    break;
                }
                else {
                    var txt = parseFloat(txtValue);
                    if (!$.isNumeric(txt)) {
                        
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Non-numeric entry is not allowed.');
                        valid = 1;
                        break;
                    }
                    else if (txt < 0 || txt > 100) {
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        valid = 1;
                        break;
                    }
                    else if ((!isNaN(txt)) && (txt % 1 != 0) && (!checkDecimal(txt))) {
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Decimal upto 2 places is allowed.');
                        valid = 1;
                        break;
                    }
                    else {
                        WeightingsValue.push(txt);
                        sum += txt;
                    }
                }
            }
            if (valid == 1) {
                AIWViewModel.ErrorStatus(1);
            }
            if (valid == 0) {

                AIWViewModel.BULOverallWeightingsList([]);
                for (var i = 0; i < rows; i++) {
                    selectedRowId = AIWViewModel.RiskAreaList()[i].RiskAreaId();
                    for (var j = 0; j < cols; j++) {

                        selectedColId = AIWViewModel.BusinessLevelDetailsList()[j].DetailId();
                        wValue = WeightingsValue[i];
                        var newObj = new WeightingModel({ 'Id': selectedRowId, 'BuId': selectedColId, 'WeightingValue': wValue });
                        AIWViewModel.BULOverallWeightingsList.push(newObj);
                    }
                }
                $('#tblAMLOverallWeightingsBUL-' + AIWViewModel.ClickedLevelDetailId()).remove();
                BULevelOverallWeightingsTable(1);
                GetTotalWeightingsBULOverall();
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: copyDataBULOverall() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function copyData(event) {
        AIWViewModel.CopyDataButtonClicked(true);
        copyDataRA();
        
    }
    function saveWeightings() {
        try 
        {
           // debugger;
            $('#loadingMainImgDivIWAMLRA_IW').show();
            $('#loadingMainImgDivIWAMLRA_Levels_OverALL').hide();
            $('#RiskAreaTabDiv').hide();
            $("#lblErrorAMLControls").hide();
          //  $('#QualTab_IW').hide();
            AIWViewModel.SaveButtonClick(true);
            if (AIWViewModel.WeightingsType() == 'OC') {
                saveBULOverallWeightings();
            }
            else if (AIWViewModel.WeightingsType() == 'Normal') {
                saveBULWeightings();
            }
            else {
                $("#lblAMLError-" + AIWViewModel.RAId()).hide();
                var cols = AIWViewModel.BusinessUnitsListIW().length;
                if (AIWViewModel.RAId() == "AML_OVERALL") {
                    var rows = AIWViewModel.RiskAreaList().length - 1;
                    var valid = 1;
                    var check = 0;
                    for (var i = 0; i < cols; i++) {
                        var sum = 0.00;
                        for (var j = 0; j < rows; j++) {
                            if ($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                               $($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                            }
                            if (!$.isNumeric($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                                valid = 0;
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('Non-numeric values are not allowed.');
                                check = 1;
                            }
                            else if ($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                                valid = 0;
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('Value should be in range of (0-100).');
                                check = 1;
                            }
                            else {
                                sum += parseFloat($($('#tblAMLWeightingsOverall tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                            }
                        }
                        if (sum.toFixed(2) != 100.00 && sum != 0.00) {
                            if (check == 0) {
                                valid = 0;
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('The total for weightings across factors should be 100% for business unit ' + AIWViewModel.BusinessUnitsList()[i].BusinessUnit_Name() + '.');
                                break;
                            }
                        }
                    }
                    if (valid == 0) {
                        AIWViewModel.ErrorStatus(1);
                        $('#loadingMainImgDivIWAMLRA_IW').hide();
                        $('#RiskAreaTabDiv').show();
                        $('#QualTab_IW').show();
                    }
                    if (valid == 1) {
                        try {
                            buildSaveOverallWeightingsList();
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/SaveOverallWeightings?RiskAreaType=" + AIWViewModel.SelectedAssessmentId() + "&Filter=A&RiskAreaId=" + AIWViewModel.RAId(),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json',
                                data: JSON.stringify($.map(AIWViewModel.OverallWeightingsListSave(), function (item) {
                                    return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                                }))
                            })
                            .success(ajaxSuccessOverall)
                            .fail(ajaxFailOverall);
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveOverallWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }

                        function ajaxSuccessOverall(jsonResult, status) {
                            try {
                                if (jsonResult != null && jsonResult > 0 ) {
                                    if (!(AIWViewModel.RiskAreaTabClicked())) {
                                        $('#tblAMLWeightingsOverall').remove();
                                        GetOverallWeightings();
                                        GetTotalWeightings();
                                    }
                                    logger.logSuccess('Overall Inherent Weightings saved successfully.', 'Success', system.getModuleId(AIWViewModel), true);
                                }
                                else {
                                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(AIWViewModel), true);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveOverallWeightings() method in AMLInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }

                        function ajaxFailOverall(error, status) {
                            try {
                                if (error.status == 401) {
                                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                                }
                                else {
                                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveOverallWeightings() method in AMLInherentWeightings.js';
                                    logger.logMessage(msg);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveOverallWeightings() method in AMLInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }
                    }

                }
                else {
                    var rows = AIWViewModel.RiskAreaListIW().length;
                    var valid = 1;
                    var check = 0;
                    for (var i = 0; i < cols; i++) {
                        var sum = 0.00;
                        for (var j = 0; j < rows; j++) {
                            var text = $("#txt_weighting_" + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + "_" + AIWViewModel.RiskAreaListIW()[j].RiskAreaId()).val();
                            
                            if (text == "") {
                                $("#txt_weighting_" + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + "_" + AIWViewModel.RiskAreaListIW()[j].RiskAreaId()).val(0);
                                $('#loadingMainInherentDiv').hide();
                                $('#WeightingsTableBU').show();
                                break;
                                //if ($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                                // $($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                             //   $($($('#WeightingsTable1 tbody tr').get(i)).find('td').get(j)).find('input').get(0).val(0);

                            //if ($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value == "") {
                            //    $($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild).val(0);
                            }
                           // if (!$.isNumeric($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) {
                            if (!$.isNumeric(text)) {
                                valid = 0;
                               
                                $("#lblErrorAMLControls").show();
                                $("#lblErrorAMLControls").text('Non-numeric values are not allowed.');
                                check = 1;
                                $('#loadingMainInherentDiv').hide();
                                $('#WeightingsTableBU').show();
                                break;
                                //$("#lblErrorAMLControls-" + AIWViewModel.RAId()).show();
                                //$("#lblErrorAMLControls-" + AIWViewModel.RAId()).text('Non-numeric values are not allowed.');
                                
                            }
                        //    else if ($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value < 0 || $($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value > 100) {
                            else if (text < 0 || text > 100) {
                            valid = 0;
                                //$("#lblAMLError-" + AIWViewModel.RAId()).show();
                                //$("#lblAMLError-" + AIWViewModel.RAId()).text('Value should be in range of (0-100).');
                                $("#lblErrorAMLControls").show();
                                $('#WeightingsTableBU').show();
                                $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                                $('#loadingMainInherentDiv').hide();
                                break;
                               
                            }
                        //    else if ((!isNaN($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value)) && ($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value % 1 != 0) && (!checkDecimal($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value))) {
                            else if ((!isNaN(text)) && (text % 1 != 0) && (!checkDecimal(text))) {
                            valid = 0;
                                $("#lblAMLError-" + AIWViewModel.RAId()).show();
                                $("#lblAMLError-" + AIWViewModel.RAId()).text('Decimal upto 2 places is allowed.');
                                check = 1;
                            }
                            else {
                                sum += parseFloat(text);
                                //sum += parseFloat($($('#tblAMLWeightings-' + AIWViewModel.RAId() + ' tbody tr').get(j)).find('td').get(i).firstChild.firstChild.value);
                            }
                        }
                        if (sum.toFixed(2) != 100.00) {--here
                            //if (sum != 100 ) {
                            if (check == 0) {
                                valid = 0;
                                $('#loadingMainInherentDiv').hide();
                                $('#WeightingsTableBU').show();
                                $("#lblErrorAMLControls").show();
                                $("#lblErrorAMLControls").text('The total for weightings should be 100% for business unit ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + '.');
                                break;
                            }
                        }
                    }
                    if (valid == 0) {
                        AIWViewModel.ErrorStatus(1);
                        $('#loadingMainImgDivIWAMLRA_IW').hide();
                        $('#RiskAreaTabDiv').show();
                        $('#QualTab_IW').show();
                    }
                    if (valid == 1) {
                        try {
              
                            buildSaveWeightingsList();
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            $.ajax({
                                url: "/api/WeightingsThresholds/SaveRiskFactorWeightings?RiskAreaType=" + AIWViewModel.SelectedAssessmentId() + "&Filter=" + AIWViewModel.AreaTypeFlag() + "&RiskAreaId=" + AIWViewModel.ClickedSubRiskAreaId() + "&SurveyCategoryID=" + AIWViewModel.SelectedSurveyComponentId(),
                                headers: headers,
                                type: "POST",
                                contentType: 'application/json',
                                dataType: 'json',
                                async: false,
                                data: JSON.stringify($.map(AIWViewModel.WeightingsListSave(), function (item) {
                                    return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                                }))
                            })
                            .success(ajaxSuccess)
                            .fail(ajaxFail);
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxCcall in saveWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }

                        function ajaxSuccess(jsonResult, status) {
                            try {
                                if (jsonResult != null && jsonResult>0 ) {
                                   
                                    $('#loadingMainImgDivIWAMLRA_IW').hide();
                                    if(AIWViewModel.AreaTypeFlag() === 'F')
                                        GetWeightings(GetWeightingsAjax);
                                    else
                                        GetOverAllSubAreas();

                                
                                    logger.logSuccess('Weightings for Risk Area saved successfully.', 'Success', system.getModuleId(AIWViewModel), true);
                                } else {
                                    logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(AIWViewModel), true);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightings() method in AMLInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }

                        function ajaxFail(error, status) {
                            try {
                                if (error.status == 401) {
                                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            navigation.unauthorized();
                                    })
                                }
                                else {
                                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightings() method in AMLInherentWeightings.js';
                                    logger.logMessage(msg);
                                }
                            }
                            catch (e) {
                                var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightings() method in AMLInherentWeightings.js';
                                logger.logMessage(msg);
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: savelWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }


    function BUModel(item) {
        try {
            var self = this;
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.rowData = item.rowData;
        }
        catch (e) {
            var msg = 'exception' + e + 'source: AreaModel() in AmlControlRiskHeatMap.js';
            logger.logMessage(msg);
        }
    }



    function saveBULWeightings() {
        try {
            var colsBUL = AIWViewModel.RiskAreaList().length - 1;
            var rows = AIWViewModel.BusinessUnitsLowestLevelList().length;
            var tableId = '#tblAMLWeightingsBU-' + AIWViewModel.ClickedLevelDetailId();
            var valid = 1;
            var check = 0;
            for (var i = 0; i < colsBUL; i++) {
                var sum = 0.00;

                for (var j = 0; j < rows; j++) {
                    if ($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value == "") {
                        $($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild).val(0);
                    }
                    if (!$.isNumeric($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value)) {
                        valid = 0;
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Non-numeric values are not allowed.');
                        check = 1;
                    }
                    else if ($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value < 0 || $($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value > 100) {
                        valid = 0;
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('Value should be in range of (0-100).');
                        check = 1;
                    }
                    else {
                        sum += parseFloat($($(tableId + ' tbody tr').get(j)).find('td').get(i + 1).firstChild.firstChild.value);
                    }
                }
                if (sum.toFixed(2) != 100.00 && sum.toFixed(2) != 0.00) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).show();
                        $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).text('The total for weightings across business levels should be 100% for risk area ' + AIWViewModel.RiskAreaList()[i].RiskAreaName() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                AIWViewModel.ErrorStatus(1);
                $('#loadingMainImgDivIWAMLRA_IW').hide();
                $('#RiskAreaTabDiv').show();
                $('#QualTab_IW').show();
            }
            if (valid == 1) {
                try {
                    buildSaveWeightingsList();
                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveOverallWeightingsBUL?RiskAreaType=" + AIWViewModel.SelectedAssessmentId() + "&BUL_Entity_ID=" + AIWViewModel.ClickedLevelDetailId(),//to save the bu level wieghtings.
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        data: JSON.stringify($.map(AIWViewModel.BULWeightingsListSave(), function (item) {
                            return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccessOverallBU)
                    .fail(ajaxFailOverallBU);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCall in saveBULWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccessOverallBU(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult > 0) {
                            $(tableId).remove();
                            GetBUlevelWeightings();
                            checkBULevelWeighting = 1;
                            BULevelWeightingsTable(checkBULevelWeighting);
                            GetTotalWeightingsBUL();
                            $("#lblAMLError-" + AIWViewModel.ClickedLevelDetailId()).hide();
                            logger.logSuccess('Overall Inherent Weightings for Business Unit Levels saved successfully.', 'Success', system.getModuleId(AIWViewModel), true);
                        }
                        else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(AIWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveBULWeightings() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFailOverallBU(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveBULWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveBULWeightings() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveBULWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function saveBULOverallWeightings() {
        try {
            //debugger;
            var rows = AIWViewModel.RiskAreaListIW().length;
            var cols = AIWViewModel.BusinessUnitsListIW().length;
            var valid = 1;
            var check = 0;
            for (var i = 0; i < cols; i++) {
                var sum = 0.00;
                for (var j = 0; j < rows; j++) {
                    var text = $("#txt_weighting_" + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + "_" + AIWViewModel.RiskAreaListIW()[j].RiskAreaId()).val();

                    if (text == "") {
                        $("#txt_weighting_" + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + "_" + AIWViewModel.RiskAreaListIW()[j].RiskAreaId()).val(0);
                    }
                    if (!$.isNumeric(text)) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Non-numeric values are not allowed.');
                        check = 1;
                    }
                    else if (text < 0 || text > 100) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Value should be in range of (0-100).');
                        check = 1;
                    }
                    else if ((!isNaN(text)) && (text % 1 != 0) && (!checkDecimal(text))) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('Decimal upto 2 places is allowed.');
                        check = 1;
                    }
                    else {
                        sum += parseFloat(text);
                    }
                }
                if (sum.toFixed(2) != 100.00) {
                    if (check == 0) {
                        valid = 0;
                        $("#lblErrorAMLControls").show();
                        $("#lblErrorAMLControls").text('The total for weightings across areas should be 100% for business unit ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '.');
                        break;
                    }
                }
            }
            if (valid == 0) {
                AIWViewModel.ErrorStatus(1);
                $('#loadingMainImgDivIWAMLRA_IW').hide();
                $('#loadingMainInherentDiv').hide();
                $('#RiskAreaTabDiv').show();
                $('#QualTab_IW').show();
            }
            if (valid == 1) {
                try {
                    buildSaveWeightingsList();

                    var csrfToken = $("input[name='__RequestVerificationToken']").val();
                    var headers = appsecurity.getSecurityHeaders();
                    headers.__RequestVerificationToken = csrfToken;
                    var clickriskid = 0;
                    if (AIWViewModel.BusinessLevelOCFlag() == true) {
                        clickriskid = AIWViewModel.LastClickedLevelDetailId();
                    }
                    else {
                        clickriskid = AIWViewModel.ClickedLevelDetailId();
                    }
                    $.ajax({
                        url: "/api/WeightingsThresholds/SaveOverallWeightings?RiskAreaType=" + AIWViewModel.SelectedAssessmentId() + "&Filter=F&RiskAreaId=" + clickriskid + "&SurveyCategoryID=" + AIWViewModel.SelectedSurveyComponentId(),
                        headers: headers,
                        type: "POST",
                        contentType: 'application/json',
                        dataType: 'json',
                        async: false,
                        data: JSON.stringify($.map(AIWViewModel.OverallWeightingsListSave(), function (item) {
                            return { Id: item.Id(), BuId: item.BuId(), WeightingValue: item.WeightingValue() };
                        }))
                    })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxCcall in saveWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }

                function ajaxSuccess(jsonResult, status) {
                    try {
                        if (jsonResult != null && jsonResult > 0) {
                            AIWViewModel.BusinessLevelOCFlag(false);
                            $('#loadingMainImgDivIWAMLRA_IW').hide();
                            GetBUlevelWeightings();
                            logger.logSuccess('Weightings saved successfully.', 'Success', system.getModuleId(AIWViewModel), true);
                        } else {
                            logger.logError('Some error occurred while saving.', 'Error', system.getModuleId(AIWViewModel), true);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in saveWeightings() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }

                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in saveWeightings() method in AMLInherentWeightings.js';
                            logger.logMessage(msg);
                        }
                    }
                    catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in saveWeightings() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveBULOverallWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }


    function checkDecimal(value) {
        try {
            var num = parseFloat(value);
            if (num.toFixed(1) == value) {
                return true;
            }
            return num.toFixed(2) == value;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: checkDecimal() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function saveValues(event, type) {
        try {
            $("#lblAMLError-" + AIWViewModel.RAId()).hide();
            var selectedColId;
            var selectedRowId = event.currentTarget.parentNode.parentNode.parentNode.id;
            if (type == "F") {
                selectedColId = $('#tblAMLWeightings-' + AIWViewModel.RAId()).find('th').get($('#tblAMLWeightings-' + AIWViewModel.RAId()).find($(event.currentTarget.parentNode.parentNode)).index()).id;
            } else {
                selectedColId = $('#tblAMLWeightingsOverall').find('th').get($('#tblAMLWeightingsOverall').find($(event.currentTarget.parentNode.parentNode)).index()).id;
            }
            if (event.currentTarget.value == "") {
                event.currentTarget.value = 0;
            }
            else {
                if (!$.isNumeric(event.currentTarget.value)) {
                    $("#lblAMLError-" + AIWViewModel.RAId()).show();
                    $("#lblAMLError-" + AIWViewModel.RAId()).text('Non-numeric entry is not allowed.');
                }
                else if (event.currentTarget.value < 0 || event.currentTarget.value > 100) {
                    $("#lblAMLError-" + AIWViewModel.RAId()).show();
                    $("#lblAMLError-" + AIWViewModel.RAId()).text('Value should be in range of (0-100).');
                }
                else if ((!isNaN(event.currentTarget.value)) && (event.currentTarget.value % 1 != 0) && (!checkDecimal(event.currentTarget.value))) {
                    $("#lblAMLError-" + AIWViewModel.RAId()).show();
                    $("#lblAMLError-" + AIWViewModel.RAId()).text("Decimal upto only 2 places is allowed.");
                }
                else {
                    if (type == "F") {
                        for (var i = 0, j = AIWViewModel.WeightingsList().length; i < j; i++) {
                            if (AIWViewModel.WeightingsList()[i].Id() == selectedRowId && AIWViewModel.WeightingsList()[i].BuId() == selectedColId) {
                                AIWViewModel.WeightingsList()[i].WeightingValue(parseFloat(event.currentTarget.value));
                            }
                        }
                    } else {
                        for (var i = 0, j = AIWViewModel.RAWeightingsList().length; i < j; i++) {
                            if (AIWViewModel.RAWeightingsList()[i].Id() == selectedRowId && AIWViewModel.RAWeightingsList()[i].BuId() == selectedColId) {
                                AIWViewModel.RAWeightingsList()[i].WeightingValue(parseFloat(event.currentTarget.value));
                            }
                        }
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: saveValues() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function GetBUlevelWeightings() {
        try {
            //debugger;
            GetBUlevelWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetBULevelWeightings",
                data: { "RiskAreaType": AIWViewModel.SelectedAssessmentId(), "DeUid": AIWViewModel.ClickedLevelDetailId(), "ParentAreaId": AIWViewModel.ClickedRiskAreaId(), "Zat_Uid": AIWViewModel.SelectedSurveyComponentId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlevelWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
                    var mappedWeightings = $.map(jsonResult, function (result) {
                        return new WeightingModel(result);
                    });
                    checkBULevelWeighting = 1;
                    AIWViewModel.BULWeightingsList(mappedWeightings);

                    BULevelWeightingsTable(checkBULevelWeighting);
                    GetTotalWeightingsBUL();
                }
                else {
                    checkBULevelWeighting = 0;
                    BULevelWeightingsTable(checkBULevelWeighting);
                    GetTotalWeightingsBUL();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function BULevelWeightingsTable(checkBULevelWeighting) {
        try {
            checkBULevelWeighting = 1;
            var selectedRow, selectedCol;
            var rows = AIWViewModel.BusinessUnitsLowestLevelList().length;
            var j = AIWViewModel.RiskAreaList().length - 1;
            for (var i = 0; i < AIWViewModel.BusinessLevelDetailsList().length; i++) {
                var id = document.getElementById('AMLTabDiv-' + AIWViewModel.BusinessLevelDetailsList()[i].DetailId());
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + AIWViewModel.BusinessLevelDetailsList()[i].DetailId()).innerHTML = "";
                }
            }

            for (var i = 0; i < AIWViewModel.RiskAreaList().length - 1; i++) {
                var id = document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                }

            }
            var TabData =
                       '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (AIWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnAMLInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnAMLCopy-' + AIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnAMLSave-' + AIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            TabData += '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-2 control-label no-padding control-label-key">Business Unit Level Detail : </label>' +
                       '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label control-label-val">' + AIWViewModel.ClickedLevelDetailName() + '</label>' +
                        '</div><label id="lblAMLError-' + AIWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                   '<div id="outerdiv"><div id="innerdiv"><table id="tblAMLWeightingsBU-' + AIWViewModel.ClickedLevelDetailId() + '" class="table table-bordered table-condensed" cellspacing="1">' +
                    '<thead>' +
                        '<tr>';
            for (var i = 0 ; i <= j; i++) {

                if (i == 0) {
                    TabData += '<th class="site_name headcol">Business Units (Horizontal) / Risk Areas (Vertical)</th>';
                }
                else {
                    TabData += '<th class="site_name long" id="' + AIWViewModel.RiskAreaList()[i - 1].RiskAreaId() + '" title="' + AIWViewModel.RiskAreaList()[i - 1].RiskAreaName() + '">' + AIWViewModel.RiskAreaList()[i - 1].RiskAreaName() + '</th>';
                }
                //TabData += '</th>';
            }
            TabData += '</tr>' +
                '</thead>' +
                '<tbody >';
            for (var i = 0; i < rows; i++) {
                selectedRow = AIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID();
                TabData += '<tr id="' + AIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID() + '">';
                for (var k = 0; k < (j + 1) ; k++) {

                    if (k == 0) {
                        TabData += '<td class="tbl-weightings-cell headcol">';
                        TabData += AIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_Name();
                        TabData += '</td>';
                    }
                    else {
                        TabData += '<td class="tbl-weightings-cell long"><div class="input-group">';
                        selectedCol = AIWViewModel.RiskAreaList()[k - 1].RiskAreaId();
                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < AIWViewModel.BULWeightingsList().length; val++) {
                                if (AIWViewModel.BULWeightingsList()[val].Id() == AIWViewModel.BusinessUnitsLowestLevelList()[i].BusinessUnit_ID() && AIWViewModel.BULWeightingsList()[val].BuId() == AIWViewModel.RiskAreaList()[k - 1].RiskAreaId()) {


                                    TabData += '<input type="text"  class="form-control" id="' + 'GetTotalWeightingsBUL' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId() + '" value="' + AIWViewModel.BULWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                AIWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control" id="GetTotalWeightingsBUL' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            AIWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control" id="GetTotalWeightingsBUL' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';
                    }

                }

                TabData += '</tr>';
                if (i == rows - 1) {

                    TabData += '<tr>'
                    TabData += '<td class="tbl-weightings-cell headcol">';
                    TabData += "Total"
                    TabData += '</td>';

                    for (l = 0; l < AIWViewModel.RiskAreaList().length - 1; l++) {
                        TabData += '<td class="tbl-weightings-cell long"><div class="input-group">';
                        TabData += '<input type="text" disabled style="background-color:#cccccc" class="form-control" id="' + 'GetTotalWeightingsBUL' + l + AIWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                        TabData += '</td>';
                    }
                    TabData += '</tr>';
                }

            }

            TabData += '</tbody>' +
                    '</table></div></div>';
            document.getElementById('AMLTabDiv-' + AIWViewModel.ClickedLevelDetailId()).innerHTML = TabData;

            ko.applyBindingsToNode($('#btnAMLSave-' + AIWViewModel.ClickedLevelDetailId()), { click: AIWViewModel.saveWeightings }, AIWViewModel);
            ko.applyBindingsToNode($('#btnAMLCopy-' + AIWViewModel.ClickedLevelDetailId()), { click: AIWViewModel.copyData }, AIWViewModel);
            ImplementWeightingTableSecurity();
            $('#loadingMainImgDivIWAMLRA_IW').hide();
            $('#RiskAreaTabDiv').show();
            $('#QualTab_IW').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function ImplementWeightingBULevelTableSecurity() {
        try {
            if (AIWViewModel.appsecurity.WriteAccess() == false) {
                for (var i = 0; i < $('#tblAMLWeightingsBU-' + AIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblAMLWeightingsBU-' + AIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementWeightingBULevelTableSecurity() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function GetBUlevelOverallWeightings(previousFlag) {
        try {
            AIWViewModel.LastClickedLevelDetailId(previousFlag);
            GetBUlevelWeightingsAjax = {
                url: "/api/WeightingsThresholds/GetBULevelWeightings",
                data: { "RiskAreaType": AIWViewModel.SelectedAssessmentId(), "DeUid": AIWViewModel.ClickedLevelDetailId(), "ParentAreaId": 0, "Zat_Uid": AIWViewModel.SelectedSurveyComponentId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            };
            $.ajax(GetBUlevelWeightingsAjax)
           .success(ajaxSuccess)
           .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxCall in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult != 'undefined' && jsonResult != null && jsonResult != "") {
               
                    AIWViewModel.RiskAreaListIW([]);
                    var mappedControlAreas = $.map(jsonResult.AreasList, function (result) {
                        return new RiskAreas(result);
                    });
                    AIWViewModel.RiskAreaListIW(mappedControlAreas);

                    AIWViewModel.BusinessUnitsListIW([]);
                    var MappedBUModelList = $.map(jsonResult.BUList, function (result) {
                        return new BusinessUnitModel(result);
                    });
                    AIWViewModel.BusinessUnitsListIW(MappedBUModelList);

                    if ($.fn.DataTable.isDataTable('#WeightingsTable1')) {
                        var tableObj = $('#WeightingsTable1').DataTable();
                        tableObj.fixedHeader.disable();
                        tableObj.destroy();
                        $('#WeightingsTable1 tbody tr').remove();
                        $("#trOneW > th").remove();
                        $("#trTwoW > th").remove();
                        var htmlHeaders = "";

                        htmlHeaders += '<th class="" style=""><span class="glyphicon glyphicon-arrow-down"></span>Risk Areas  / <span class="glyphicon glyphicon-arrow-right"></span>Business Units</th>'
                        for (var i = 0; i < AIWViewModel.BusinessUnitsListIW().length; i++) {
                            htmlHeaders += '<th style="text-align:left;vertical-align:middle;" title="' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '" class="noSort" data-bind="text: ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + ', attr:{id: ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + ', \'title\': ' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_NameTitle() + '}, css:{\'long header-ellipsis\': true}">' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_Name() + '</th>'
                        }
                        $("#trOneW").append(htmlHeaders);

                        var htmlHeaders1 = "";
                        htmlHeaders1 += '<th class="noSort" style="border-bottom: unset !important;font-weight:700;text-align: left;vertical-align:middle;background-color:#00a3e0;">Total</th>'
                        for (var i = 0; i < AIWViewModel.BusinessUnitsListIW().length; i++) {
                            htmlHeaders1 += '<th class="noSort" style="text-align:center;vertical-align:middle;background-color:white;border: 1px solid #ccc !important;">'
                            htmlHeaders1 += '<div class="input-group" style="text-align:center;vertical-align:middle;">'
                            htmlHeaders1 += '<input type="text" disabled style="font-weight: 600;position:unset !important;background-color:#cccccc;" class="form-control inputWBU" id="txt_weighting_' + AIWViewModel.BusinessUnitsListIW()[i].BusinessUnit_ID() + '" }">'
                            htmlHeaders1 += '<span class="input-group-addon">%</span>'
                            htmlHeaders1 += ' </div>'
                            htmlHeaders1 += '</th>'
                        }
                        $("#trTwoW").append(htmlHeaders1);

                    }
                    var mappedWeightings = $.map(jsonResult.WeightingsDataList, function (result) {
                        return new WeightingDataModel(result);
                    });
                    AIWViewModel.WeightingsDataList(mappedWeightings);

                    $('#loadingMainControlsDiv').hide();

                    $('#WeightingsTableBU').show();

                    var scrollHeight = "30rem";

                    if (AIWViewModel.ComposeBindingFlag()) {
                        scrollHeight = "25rem";
                    }

                    var oTable = $('#WeightingsTable1').DataTable(
                        {
                            'aoColumnDefs': [{
                                'bSortable': false,
                                "targets": "_all"
                                //'aTargets': ['noSort']
                            }],
                            "aaSorting": [],
                            scrollY: scrollHeight,
                            scrollX: true,
                            scrollCollapse: true,
                            fixedColumns: true,
                            paging: false,
                            "bInfo": false,
                            "bAutoWidth": false,
                            fixedColumns: {
                                leftColumns: 1
                            },
                            fixedheader: {
                                header: true
                            },
                        });

                    $('#WeightingsTable1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");

                    GetTotalWeightings();

                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();
                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetBUlevelOverallWeightings() method in AMLInherentWeightings.js';
                logger.logMessage(msg);
            }
        }
    }
    function BULevelOverallWeightingsTable(checkBULevelOverallWeighting) {
        try {
            if (AIWViewModel.BusinessLevelDetailsList().length != 0) {
            checkBULevelWeighting = 1;
            var selectedRow, selectedCol;
            var rows = AIWViewModel.RiskAreaList().length - 1;//-1 to removing the overall tab
            var j = AIWViewModel.BusinessLevelDetailsList().length - 1;//-1 to removing the overall tab
            var buHeight;
            var tdHeight;
            for (var i = 0; i < AIWViewModel.BusinessLevelDetailsList().length; i++) {
                colHeight = Math.ceil(AIWViewModel.BusinessLevelDetailsList()[i].DetailName().length / 13)
                if (i == 0) {
                    buHeight = colHeight;

                }
                if (buHeight < colHeight) {
                    buHeight = colHeight;
                }
            }
            tdHeight = 3;
            if (buHeight > 1) {
                tdHeight = tdHeight + ((buHeight - 1) * 1.5);
            }
            var bucoulmnheight = tdHeight / 2;
            for (var i = 0; i < AIWViewModel.BusinessLevelDetailsList().length; i++) {// this is for removing the previous tables from HTML
                var id = document.getElementById('AMLTabDiv-' + AIWViewModel.BusinessLevelDetailsList()[i].DetailId());
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + AIWViewModel.BusinessLevelDetailsList()[i].DetailId()).innerHTML = "";
                }
            }

            for (var i = 0; i < AIWViewModel.RiskAreaList().length - 1; i++) {
                var id = document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                if (id == null || id == undefined || id == '') {

                }
                else {
                    document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                }

            }
           
            var TabData = '<div class="well well-sm col-xs-12 col-sm-12 col-md-12 col-lg-12">';
            if (AIWViewModel.appsecurity.WriteAccess()) {
                TabData += '<span id="spnAMLInherent" class="pull-right">' +
                        '<button type="button" class="btn btn-primary btn-sm" id="btnAMLCopy-' + AIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.copyData" title="Copy values from the first column to all">' +
                            '<i class="fa fa-copy"></i> Copy to All' +
                        '</button>' +
                        '<button type="button" class="btn btn-success btn-sm" id="btnAMLSave-' + AIWViewModel.ClickedLevelDetailId() + '" data-bind="click: $root.saveWeightings" title="Click to Save">' +
                            '<i class="fa fa-check"></i> Save' +
                        '</button></span>';
            }
            //'<label class="col-xs-3 col-sm-3 col-md-3 col-lg-2 control-label no-padding">Business Unit Level Detail : </label>' +
            TabData += '<label style="padding-left:1em" class="col-xs-3 col-sm-3 col-md-3 col-lg-3  control-label control-label-border">' + AIWViewModel.ClickedLevelDetailName() + '</label>' +
                   '</div><label id="lblAMLError-' + AIWViewModel.ClickedLevelDetailId() + '" class=" control-label col-xs-12 col-sm-12 col-md-12 col-lg-12 alert alert-danger alerts-inherent" style="display:none"></label>' +
                   //'<table id="tblAMLOverallWeightingsBUL-' + AIWViewModel.ClickedLevelDetailId() + '" class="table table-bordered table-condensed" cellspacing="1">' +
                   // '<thead>' +
                   //     '<tr>'+
            //Corner cell
                   '<div class="wclscscroll corner-header">' +
                       '<table style="width:100%">' +
                             '<tr>' +
                                                    '<th class="site_name label-info headcol-min1 text-center" title="Risk Sub-Factor Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-right"></span>Business Unit Level Detail</th>' +


                            '</tr>' +
                            '<tr>' +
                             '<th class="site_name label-info headcol-min1 text-center" title="Risk Area Name" style="height:' + bucoulmnheight + 'em !important;"><span class="glyphicon glyphicon-arrow-down"></span>Risk Area Name</th>' +
                             '</tr>' +
                          '</table>' +
                     '</div>' +
            //Corner cell end
            //Header Business units
                           '<div class="wclscscroll column-headers" style="overflow-y:hidden !important;" id="clscroll-column-headers' + AIWViewModel.RAId() + '" style="width:65%;">' +
                               '<table>' +
                                   '<tr>'


                       for (var i = 0 ; i < j; i++) {
                           //here akshay

 
                           TabData += '<th class="site_name long label-info" style="height:' + tdHeight + 'em;" id="' + AIWViewModel.BusinessLevelDetailsList()[i].DetailId() + '" title="' + AIWViewModel.BusinessLevelDetailsList()[i].DetailName() + '">' + AIWViewModel.BusinessLevelDetailsList()[i].DetailName() + '</th>';

                //TabData += '</th>';
            }
                   
            TabData += '</tr>' +

                              '</table>' +
                             '</div>';

            //Header Business units end
            //Row headers
                   TabData += '<div class="wclscscroll-row row-headers" id="clscroll-row-headers' + AIWViewModel.RAId() + '" style="width:100%">' +
                       '<table>';
            for (var i = 0; i < rows; i++) {
                var factText = AIWViewModel.RiskAreaList()[i].RiskAreaName();
                var length = parseInt(factText.length);
                var colHeight = parseInt((Math.ceil(length / 40)));
                colHeight = colHeight + 4;


                TabData += '<tr><td style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell Weightingsheader">';
                        TabData += AIWViewModel.RiskAreaList()[i].RiskAreaName();
                       TabData += '</td></tr>'
                    }
                   TabData += '</table></div>';
            //Row headers end
            //Data 
                   TabData += '<div class="wclscscroll table-content" id="clscroll-content' + AIWViewModel.RAId() + '" style="width:65%;">' +
      '<table id="tblAMLOverallWeightingsBUL-' + AIWViewModel.ClickedLevelDetailId() + '" ><tbody>';
                   for (var i = 0; i < rows; i++) {
                       selectedRow = AIWViewModel.RiskAreaList()[i].RiskAreaId();
                       TabData += '<tr id="' + AIWViewModel.RiskAreaList()[i].RiskAreaId() + '">';
                       var factText = AIWViewModel.RiskAreaList()[i].RiskAreaName();
                       var length = parseInt(factText.length);
                       var colHeight = parseInt((Math.ceil(length / 40)));
                       colHeight = colHeight + 4;
                       for (var k = 0; k < (j) ; k++) {
                           if (AIWViewModel.appsecurity.WriteAccess() == false) {
                               TabData += '<td id=' + AIWViewModel.BusinessLevelDetailsList()[k].DetailId() + ' style="min-height:42px;height:' + colHeight + 'em !important;" class="disabled tbl-weightings-cell long weightingspadding"><div class="input-group">';
                           }
                           else {
                               TabData += '<td id=' + AIWViewModel.BusinessLevelDetailsList()[k].DetailId() + ' style="min-height:42px;height:' + colHeight + 'em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';

                           }
                           selectedCol = AIWViewModel.BusinessLevelDetailsList()[k].DetailId();
                        if (checkBULevelWeighting == 1) {
                            var check_new = true;
                            for (var val = 0; val < AIWViewModel.BULOverallWeightingsList().length; val++) {
                                   if (AIWViewModel.BULOverallWeightingsList()[val].Id() == AIWViewModel.RiskAreaList()[i].RiskAreaId() && AIWViewModel.BULOverallWeightingsList()[val].BuId() == AIWViewModel.BusinessLevelDetailsList()[k].DetailId()) {


                                    TabData += '<input  type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="' + 'txt_BULOweighting' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId() + '" value="' + AIWViewModel.BULOverallWeightingsList()[val].WeightingValue() + '"></input><span class="input-group-addon">%</span>';
                                    check_new = false;
                                    break;
                                }
                            }
                            if (check_new) {

                                var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                                AIWViewModel.BULWeightingsList().push(newObj);
                                TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULOweighting' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                            }
                        } else {
                            var newObj = new WeightingModel({ 'Id': selectedRow, 'BuId': selectedCol, 'WeightingValue': 0 });
                            AIWViewModel.BULWeightingsList().push(newObj);
                            TabData += '<input type="text" class="form-control form-controlWT" data-bind="event: {keyup: $root.InputChange}" id="txt_BULOweighting' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId() + '" value="0"></input><span class="input-group-addon">%</span>';

                        }
                        TabData += '</div></td>';
                           

                    }

                       TabData += '</tr>';
                }
                   TabData += '</tbody></table></div>';
            //Total  cell

                   TabData += '<div class="wclscscroll corner-header">' +
                       '<table>' +
                  '<tr>';

                   TabData += '<td  style="min-height:42px;height:5em !important;" class="tbl-weightings-cell weightingspadding label-info">';
                    TabData += "Total"
                   TabData += '</td>' +

                   '</tr>' +

                '</table>' +
           '</div>' +
       //Total cell end  
                   //Total Data
                   '<div class="wclscscroll-footer column-footer" style="overflow-y: hidden!important;background-color:transparent" id="clscroll-column-footer' + AIWViewModel.RAId() + '">' +
                        '<table>' +
                            '<tr>'
                    for (l = 0; l < AIWViewModel.BusinessLevelDetailsList().length - 1; l++) {
                        TabData += '<td style="min-height:42px;height:5em !important;" class="tbl-weightings-cell long weightingspadding"><div class="input-group">';
                        TabData += '<input type="text" disabled style="background-color:#cccccc"class="form-control form-controlWT" id="' + 'txt_BULOweighting' + l + AIWViewModel.ClickedLevelDetailId() + '"></input><span class="input-group-addon">%</span>';
                        TabData += '</td>';
                    }
                   TabData += '</tr>' +
                   '</table></div>';

            document.getElementById('AMLTabDiv-' + AIWViewModel.ClickedLevelDetailId()).innerHTML = TabData;

            ko.applyBindingsToNode($('#btnAMLSave-' + AIWViewModel.ClickedLevelDetailId()), { click: AIWViewModel.saveWeightings }, AIWViewModel);
            ko.applyBindingsToNode($('#btnAMLCopy-' + AIWViewModel.ClickedLevelDetailId()), { click: AIWViewModel.copyData }, AIWViewModel);
            for (var i = 0; i < rows; i++) {
                for (var k = 0; k < (j + 1) ; k++) {  
                    ko.applyBindingsToNode($('#txt_BULOweighting' + i + '_' + k + '_' + AIWViewModel.ClickedLevelDetailId()), { event: { keyup: AIWViewModel.InputChange } }, AIWViewModel); 
                }
            }

            ImplementWeightingTableSecurity();
            $("#clscroll-content" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-row-headers" + AIWViewModel.RAId()).scrollTop($("#clscroll-content" + AIWViewModel.RAId()).scrollTop());
                $("#clscroll-column-headers" + AIWViewModel.RAId()).scrollLeft($("#clscroll-content" + AIWViewModel.RAId()).scrollLeft());
                $("#clscroll-column-footer" + AIWViewModel.RAId()).scrollLeft($("#clscroll-content" + AIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-headers" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + AIWViewModel.RAId()).scrollLeft($("#clscroll-column-headers" + AIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-column-footer" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + AIWViewModel.RAId()).scrollLeft($("#clscroll-column-footer" + AIWViewModel.RAId()).scrollLeft());
            });

            $("#clscroll-row-headers" + AIWViewModel.RAId()).scroll(function () {
                $("#clscroll-content" + AIWViewModel.RAId()).scrollTop($("#clscroll-row-headers" + AIWViewModel.RAId()).scrollTop());
            });
        }
            else {
                $('#RiskLevelDetailsTabDiv').css('font-weight', "bold");
                $('#RiskLevelDetailsTabDiv').get(0).innerHTML = "There are no Organizational Sub Levels configured for this Organizational Level."
            }
            $('#loadingMainImgDivIWAMLRA_IW').hide();
            $('#loadingMainImgDivIWAMLRA_Levels').hide();
            $('#AMLTabDiv-' + AIWViewModel.ClickedLevelDetailId()).show();
            $('#RiskAreaTabDiv').show();
            $('#QualTab_IW').show();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BULevelWeightingsTable() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function ImplementOverallWeightingBULevelTableSecurity() {
        try {
            if (AIWViewModel.appsecurity.WriteAccess()) {
                for (var i = 0; i < $('#tblAMLOverallWeightingsBUL-' + AIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').length; i++) {
                    $($('#tblAMLOverallWeightingsBUL-' + AIWViewModel.ClickedLevelDetailId() + ' tbody').find('input').get(i)).addClass('disabled');
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ImplementOverallWeightingBULevelTableSecurity() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    //-----------------------------------------------------------------Model Definition Starts Here-----------------------------------------------------------------------



    function RiskAreas(item) {
        try {
            var self = this;
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaName = ko.observable($('<div/>').html(item.AreaName).text());
            self.Rank = ko.observable($('<div/>').html(item.AMLRank).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ControlAreas() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }






    function RiskAreaModel(item) {
        try {
            var self = this;
            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaNameSort = ko.observable($('<div/>').html(item.RiskAreaNameSort).text())
            self.RiskAreaNameConcat = ko.observable($('<div/>').html(item.RiskAreaNameSort).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            if ($('<div/>').html(item.IsQualitative).text() == "1") {
                self.IsQualitative = ko.observable(true);
            }
            else {
                self.IsQualitative = ko.observable(false);
            }
            self.TargetRow = ko.observable();
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.hasSubArea = ko.observable(item.hasSubArea);
            self.Parent_Id = ko.observable(item.Parent_Id);
            self.AreaType = ko.observable($('<div/>').html(item.AreaType).text());
            AIWViewModel.AreaType(item.AreaType);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }



    function SurveyCategoryModel(item) {
        try {
            var self = this;
            self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
            self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
            self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
            self.SurveyType = ko.observable(item.SurveyType);
            self.Applicability = ko.observable(item.Applicability);
            self.SurveyGroupId = ko.observable(item.SurveyGroupId);
            self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
            self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
            self.IsEditable = ko.observable(item.IsEditable);
            self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
            self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }


    function RiskFactorModel(item) {
        try {
            var self = this;
            self.RiskFactorName = ko.observable($('<div/>').html(item.RiskFactorName).text());
            self.RiskFactorId = ko.observable(item.RiskFactorId);
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorModel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    };
    function BusinessUnits(item) {
        try {
            var self = this;
            self.BusinessUnit_ID = ko.observable(item.BuId);
            self.BusinessUnit_Name = ko.observable($('<div/>').html(item.BuName).text());
            self.BuAssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
            self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
            self.TargetRow = ko.observable();
        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessUnits() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    };
    function WeightingModel(item) {
        try {
            var self = this;
            self.Id = ko.observable(item.Id);
            self.BuId = ko.observable(item.BuId);
            self.WeightingValue = ko.observable(item.WeightingValue);
            if (item.Name != undefined)
                self.Name = ko.observable(item.Name);

            if (item.BuStatus != undefined)
                self.BuStatus = ko.observable(item.BuStatus);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: WeightingModel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function BusinessLevelModel(item) {
        try {
            var self = this;
            self.LevelID = ko.observable($('<div/>').html(item.BuLId).text());
            self.LevelName = ko.observable($('<div/>').html(item.BuLevelName).text());
            self.TargetRow = ko.observable();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    };
    function BusinessLevelDetail(item) {
        try {
            var self = this;
            self.DetailId = ko.observable($('<div/>').html(item.BuLevelDetailId).text()); 
            self.DetailName = ko.observable($('<div/>').html(item.BuLevelDetailName).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetail() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    };

    function ResetBULevels() {
        AIWViewModel.ClickedLevelId('');
        AIWViewModel.ClickedLevelName('');
        AIWViewModel.ClickedLevelDetailId('');
        AIWViewModel.ClickedLevelDetailName('');
    };
    //function RiskAreaTabClick(data, event) {
    //    try {
    //        $('#loadingMainImgDivIWAMLRA_IW').show();
    //        $('#RiskAreaTabDiv').hide();
    //        AIWViewModel.RiskAreaTabClicked(true);
    //        if (AIWViewModel.appsecurity.WriteAccess() == false || AIWViewModel.appsecurity.WriteAccess() == "false") {
    //            AIWViewModel.countEntry(0);
    //        }
    //        if (AIWViewModel.countEntry() == 0) {
    //            AIWViewModel.countEntry(1);
    //            AIWViewModel.WeightingsType('');
    //            AIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
    //            AIWViewModel.ClickedRiskAreaName(data.RiskAreaName());
    //            AIWViewModel.RAId(data.RiskAreaId());
    //            AIWViewModel.RAName(data.RiskAreaName());
    //            if (AIWViewModel.RAId() == "AML_OVERALL") {
    //                //$('#AMLTabDiv-' + AIWViewModel.RAId()).show();
    //                $('#NoFactorserror').hide();
    //                GetAllRiskLevels(data.RiskAreaId());

    //            }
    //            else {
    //                AIWViewModel.countLevelEntry(0);
    //                AIWViewModel.WeightingsType('RA');
    //                AIWViewModel.ShowLevelsTab(false);
    //                ResetBULevels();

    //                GetRiskFactors();
    //            }
    //        }
    //        else if ((AIWViewModel.InputChangeEvent() || AIWViewModel.CopyDataButtonClicked()) && AIWViewModel.SaveButtonClick() == false) {
    //            AIWViewModel.InputChangeEvent(false);
    //            AIWViewModel.CopyDataButtonClicked(false);
    //            app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
    //            .then(function (option) {
    //                if (option == "Save") {
    //                    if (AIWViewModel.RAId() == "AML_OVERALL") {
    //                        if (AIWViewModel.ClickedLevelId() == 'LevelOverall') {
    //                            $('#btnAMLSaveOverall').click();
    //                        }
    //                        else {

    //                            $('#btnAMLSave-' + AIWViewModel.ClickedLevelDetailId()).click();
    //                        }
    //                    }
    //                    else {
    //                        AIWViewModel.countLevelEntry(0);
    //                        $('#btnAMLSave-' + AIWViewModel.RAId()).click();
    //                    }
    //                    //AIWViewModel.countEntry(0);
    //                    if (AIWViewModel.ErrorStatus() == 1) {
    //                        AIWViewModel.ErrorStatus(0);
    //                        $('#' + AIWViewModel.RAId()).addClass('ui-tabs-active ui-state-active');
    //                        $('#' + data.RiskAreaId()).removeClass('ui-tabs-active ui-state-active');
    //                    }
    //                    else {
    //                        AIWViewModel.SaveButtonClick(false);
    //                        AIWViewModel.countEntry(0);
    //                        $('#' + AIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
    //                        $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
    //                        RiskAreaTabClick(data, event);
    //                    }
    //                }
    //                else if (AIWViewModel.ErrorStatus() == 0) {
    //                    AIWViewModel.WeightingsType('');
    //                    AIWViewModel.countEntry(1);
    //                    //AIWViewModel.ErrorStatus(1);
    //                    $('#' + AIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
    //                    $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
    //                    AIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
    //                    AIWViewModel.ClickedRiskAreaName(data.RiskAreaName());
    //                    AIWViewModel.RAId(data.RiskAreaId());
    //                    AIWViewModel.RAName(data.RiskAreaName());
    //                    if (AIWViewModel.RAId() == "AML_OVERALL") {
    //                        GetAllRiskLevels(data.RiskAreaId());

    //                    }
    //                    else {
    //                        AIWViewModel.countLevelEntry(0);
    //                        AIWViewModel.WeightingsType('RA');
    //                        AIWViewModel.ShowLevelsTab(false);
    //                        ResetBULevels();

    //                        GetRiskFactors();
    //                    }
    //                }
    //            })

    //        }
    //        else {
    //            AIWViewModel.InputChangeEvent(false);
    //            AIWViewModel.SaveButtonClick(false);
    //            AIWViewModel.CopyDataButtonClicked(false);
    //            AIWViewModel.countEntry(0);
    //            $('#' + AIWViewModel.RAId()).removeClass('ui-tabs-active ui-state-active');
    //            $('#' + data.RiskAreaId()).addClass('ui-tabs-active ui-state-active');
    //            RiskAreaTabClick(data, event);
    //        }

    //    }
    //    catch (e) {
    //        var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in AMLInherentWeightings.js';
    //        logger.logMessage(msg);
    //    }
    //}

    function RiskAreaTabClick(data, event) {
        try {

           
            AIWViewModel.RiskAreaTabClicked(true);
            $("#lblErrorAMLControls").hide();
            if (AIWViewModel.appsecurity.WriteAccess() == false || AIWViewModel.appsecurity.WriteAccess() == "false") {
                AIWViewModel.countEntry(0);
            }
            if (AIWViewModel.countEntry() == 0) {
                AIWViewModel.countEntry(1);
                //started
                $('#RiskLevelTabinnerDiv_IW').hide();
                $('#RiskLevelinnerTabDivforheatmnaps_IW').hide();
                $('#factorstab_IW').hide();
                $('#FactorReportDownload').hide();
                // $('#WeightingsBtnQuan').hide();
                //  $('#ThresholdsBtn').hide();
                AIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
                AIWViewModel.WeightingsType('');
                AIWViewModel.ThemeId(data.RiskAreaId());
                AIWViewModel.RAId(data.RiskAreaId());
                AIWViewModel.RAName(data.RiskAreaName());
                AIWViewModel.ClickedRiskAreaName(data.RiskAreaNameSort());
                AIWViewModel.RiskFactorList([])
                $('#NoFactorsError').hide();
                $('#NoSubFactorsError').hide();
                if (data.IsQualitative()) {
                    AIWViewModel.ClickedRiskAreaType('QUAL');
                }
                else {
                    AIWViewModel.ClickedRiskAreaType('QUAN');}
                AIWViewModel.ClickedRiskAreaType('QUAL');
                AIWViewModel.WeightingsType('RA');
                AIWViewModel.hasSubArea(data.hasSubArea());
                AIWViewModel.Parent_Id(data.Parent_Id());
                AIWViewModel.Type(data.AreaType());
                $("#loadingMainImgDivIW").hide();
                $("#loadingImgOrCalc_IW").show();

            //ended
                if (AIWViewModel.RAId() == "AML_OVERALL") {
                    //$('#AMLTabDiv-' + AIWViewModel.RAId()).show();
                    $('#NoFactorserror').hide();
                    GetAllRiskLevels(data.RiskAreaId());

                }
                else {
                    AIWViewModel.countLevelEntry(0);
                    AIWViewModel.WeightingsType('RA');
                    if (data.IsQualitative()) {
                        if (data.hasSubArea() == true)
                            GetAllRiskSubAreas();
                        else {
                            AIWViewModel.ClickedSubRiskAreaId(data.RiskAreaId());
                            GetAllRiskFactors();
                            //  GetAllQualitativeData();
                        }
                    }
                    else {
                        AIWViewModel.ClickedSubRiskAreaId(data.RiskAreaId());
                        GetAllRiskFactors();
                    }


                }
            }
            else if ((AIWViewModel.InputChangeEvent() || AIWViewModel.CopyDataButtonClicked()) && AIWViewModel.SaveButtonClick() == false) {
                AIWViewModel.InputChangeEvent(false);
                AIWViewModel.CopyDataButtonClicked(false);
                app.showMessage("Please save the data before moving to another tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                    .then(function (option) {
                        if (option == "Save") {
                            if (AIWViewModel.RAId() == "AML_OVERALL") {
                                if (AIWViewModel.ClickedLevelId() == 'LevelOverall') {
                                    $('#btnAMLSaveOverall').click();
                                }
                                else {

                                    saveWeightings();
                                }
                            }
                            else {
                                AIWViewModel.countLevelEntry(0);
                                saveWeightings();
                            }
                            //AIWViewModel.countEntry(0);
                            if (AIWViewModel.ErrorStatus() == 1) {
                                AIWViewModel.ErrorStatus(0);
                                $('#' + AIWViewModel.RAId() + "_A").addClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId() + "_A").removeClass('ui-tabs-active ui-state-active');
                                AIWViewModel.SaveButtonClick(false);
                            }
                            else {
                                AIWViewModel.SaveButtonClick(false);
                                AIWViewModel.countEntry(0);
                                $('#' + AIWViewModel.RAId() + "_A").removeClass('ui-tabs-active ui-state-active');
                                $('#' + data.RiskAreaId() + "_A").addClass('ui-tabs-active ui-state-active');
                                RiskAreaTabClick(data, event);
                            }
                        }
                        else if (AIWViewModel.ErrorStatus() == 0) {
                            AIWViewModel.WeightingsType('');
                            AIWViewModel.countEntry(1);
                            //AIWViewModel.ErrorStatus(1);
                            $('#' + AIWViewModel.RAId() + "_A").removeClass('ui-tabs-active ui-state-active');
                            $('#' + data.RiskAreaId() + "_A").addClass('ui-tabs-active ui-state-active');
                            AIWViewModel.ClickedRiskAreaId(data.RiskAreaId());
                            AIWViewModel.ClickedRiskAreaName(data.RiskAreaName());
                            AIWViewModel.RAId(data.RiskAreaId());
                            AIWViewModel.RAName(data.RiskAreaName());
                            if (AIWViewModel.RAId() == "AML_OVERALL") {
                                GetAllRiskLevels(data.RiskAreaId());

                            }
                            else {
                                AIWViewModel.countLevelEntry(0);
                                AIWViewModel.WeightingsType('RA');
                                AIWViewModel.ShowLevelsTab(false);

                                if (data.hasSubArea() == true)
                                    GetAllRiskSubAreas();
                                else {
                                    GetAllRiskFactors();
                                    //  GetAllQualitativeData();
                                }


                            }
                        }
                    })

            }
            else {
                AIWViewModel.InputChangeEvent(false);
                AIWViewModel.SaveButtonClick(false);
                AIWViewModel.CopyDataButtonClicked(false);
                AIWViewModel.countEntry(0);
                $('#' + AIWViewModel.RAId() + "_A").removeClass('ui-tabs-active ui-state-active');
                $('#' + data.RiskAreaId() + "_A").addClass('ui-tabs-active ui-state-active');
                RiskAreaTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaTabClick() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
    }


    function GetAllRiskSubAreas() {
        try {

            $.ajax({
                url: "/api/Configuration/GetAllRiskAreas",
                data: {
                    "AreaType": "NULL", "ParentAreaId": AIWViewModel.ClickedRiskAreaId(), "TypeId": "W",
                    "SurveyCategoryID": AIWViewModel.SelectedSurveyComponentId(), "AssessmentTypes": AIWViewModel.AssessmentTypeId(),
                    "ScreenType": 'IWX'
                },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllRiskSubAreas() method in AmlInherentRiskAssessment.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            if (jsonResult != null) {
                if (jsonResult[0].RiskAreaId != 0) {
                    $('#NoRiskAreasError').hide();
                    var mappedRiskAreaList = $.map(jsonResult, function (result) {
                        var RiskAreaModelObj = new RiskAreaModel(result);
                        addNewDivTab(RiskAreaModelObj);
                        return RiskAreaModelObj;
                    });
                    AIWViewModel.SubRiskAreaList([]);
                    AIWViewModel.SubRiskAreaList(mappedRiskAreaList);
                    $('#RASubTab_IW').tabs();
                    $('#RASubTab_IW').tabs('refresh');
                    $('#RASubTab_IW').tabs({ active: 0 });

                    //  RASubTab_IW
                    $("#loadingImgOrCalc_IW").hide();
                    $($('#RiskSubAreaUl_IW li').get(0)).trigger('click');
                    scrollableTabs();
                }
                else {
                    $('#loadingMainImgDivIWAMLRA_IW').hide();
                    $('#NoRiskAreasError').show();
                }
            }
            else {
                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLRaViewModel), true);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskSubAreas() method in AmlInherentRiskAssessment.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskSubAreas() method in AmlInherentRiskAssessment.js';
                logger.logMessage(msg);
            }
        };
    }


    function BusinessLevelTabClick(data, event) {
        try 
        {

            $('#loadingMainInherentDiv').show();
            AIWViewModel.WeightingsType('OC');
            AIWViewModel.ClickedLevelDetailId(data.LevelID());

            //$('#AMLTabDiv-' + AIWViewModel.ClickedLevelDetailId()).hide();
            //$('#loadingMainImgDivIWAMLRA_Levels').show();
            //if (AIWViewModel.appsecurity.WriteAccess() == false || AIWViewModel.appsecurity.WriteAccess() == "false") {
            //    AIWViewModel.countLevelEntry(0);
            //}
            //AIWViewModel.RiskAreaTabClicked(false);
            //AIWViewModel.ClickedLevelId(data.LevelID());
            //AIWViewModel.ClickedLevelName(data.LevelName());
            //AIWViewModel.LastClickedLevelDetailId(AIWViewModel.ClickedLevelDetailId());
            if (AIWViewModel.countLevelEntry() == 0) {
                AIWViewModel.countLevelEntry(1);

                GetBUlevelOverallWeightings(data.LevelID());
                //var id = document.getElementById('AMLTabDiv-' + AIWViewModel.LastClickedLevelDetailId());
                //if (id != null && id != undefined && id != '') {
                //    document.getElementById('AMLTabDiv-' + AIWViewModel.LastClickedLevelDetailId()).innerHTML = "";
                //}
                //for (var i = 0; i < AIWViewModel.RiskAreaList().length; i++) {
                //    document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                //}
                //var idRA = document.getElementById('AMLTabDiv-' + AIWViewModel.RAId());
                //if (idRA != null && idRA != undefined && idRA != '') {
                //    document.getElementById('AMLTabDiv-' + AIWViewModel.RAId()).innerHTML = "";
                //}

                //if (AIWViewModel.ClickedLevelId() == 'LevelOverall') {
                //    $('#AMLTabDiv-' + AIWViewModel.RAId()).show();
                //    $('#loadingMainImgDivIWAMLRA_Levels_OverALL').show();
                //    AIWViewModel.ClickedLevelDetailId(AIWViewModel.ClickedLevelId());
                //    AIWViewModel.WeightingsType('OA');
                //    AIWViewModel.ShowDetailsTab(false);
                //    addNewDivTabBULevelOverall(AIWViewModel.RAId());
                //    GetOverallWeightings();
                //}
                //else {
                //    AIWViewModel.WeightingsType('BUL');
                //    AIWViewModel.ShowDetailsTab(true);
                //    $('#loadingMainImgDivIWAMLRA_Levels').show();
                //    if (Number.isInteger(data.LevelID())) {
                //        GetRiskLevelDetails(data.LevelID(), data.LevelName());

                //    }
                //    else {
                //        AIWViewModel.LevelIdNumber(data.LevelID().match(/\d/g).join(""));
                //        GetRiskLevelDetails(AIWViewModel.LevelIdNumber(), data.LevelName());
                //    }
                //    if (data.LevelID().toString().includes('OVERALL')) {
                //        data.LevelID(data.LevelID());
                //        data.LevelName(data.LevelName());
                //    } else {
                //        data.LevelID(data.LevelID() + 'OVERALL')
                //        data.LevelName(data.LevelName());
                //    }
                //    BusinessLevelDetailTabClick(data);
                //}
            }
            else if ((AIWViewModel.InputChangeEvent() || AIWViewModel.CopyDataButtonClicked()) && AIWViewModel.SaveButtonClick() == false) {
                AIWViewModel.InputChangeEvent(false);
                AIWViewModel.CopyDataButtonClicked(false);
                
                app.showMessage("Please save the data before moving to other tab, otherwise the changes made will be lost.", "Warning", ["Save", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus" })
                .then(function (option) {
                    if (option == "Save") {
                       // debugger;
                        AIWViewModel.BusinessLevelOCFlag(true);
                        saveWeightings();
                        if (AIWViewModel.ErrorStatus() == 1) {
                            AIWViewModel.ErrorStatus(0);
                            $('#RfTab_IWO ul #' + AIWViewModel.LastClickedLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                            $('#RfTab_IWO ul #' + data.LevelID()).removeClass('ui-tabs-active ui-state-active');
                            //$('#RiskLevelTabDiv_IWO ul #' + AIWViewModel.LastClickedLevelDetailId()).addClass('ui-tabs-active ui-state-active');
                            //$('#RiskLevelTabDiv_IWO ul #' + data.LevelID()).removeClass('ui-tabs-active ui-state-active');
                           
                            AIWViewModel.SaveButtonClick(false);
                        }
                        else {
                            AIWViewModel.SaveButtonClick(false);
                            AIWViewModel.countLevelEntry(0);
                            $('#RfTab_IWO ul #' + AIWViewModel.LastClickedLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                            $('#RfTab_IWO ul #' + data.LevelID()).addClass('ui-tabs-active ui-state-active');
                            //for (var i = 0; i < AIWViewModel.RiskAreaList().length; i++) {
                            //    if (event.currentTarget.id == AIWViewModel.RiskAreaID()) {

                            //    }
                            //    else {
                            BusinessLevelTabClick(data, event);
                            //    }
                            //}
                        }
                    }
                    else {
                        AIWViewModel.countLevelEntry(0);
                        $('#RfTab_IWO ul #' + AIWViewModel.LastClickedLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                        $('#RfTab_IWO ul #' + data.LevelID()).addClass('ui-tabs-active ui-state-active');
                        BusinessLevelTabClick(data, event);
                    }
                });
            }
            else {
                AIWViewModel.SaveButtonClick(false);
                AIWViewModel.countLevelEntry(0);
                $('#RfTab_IWO ul #' + AIWViewModel.LastClickedLevelDetailId()).removeClass('ui-tabs-active ui-state-active');
                $('#RfTab_IWO ul #' + data.LevelID()).addClass('ui-tabs-active ui-state-active');
                BusinessLevelTabClick(data, event);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelTabClick() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    function BusinessLevelDetailTabClick(data) {
        try {
            AIWViewModel.ClickedLevelDetailId(data.LevelID());
            AIWViewModel.ClickedLevelDetailName(data.LevelName() + '- OVERALL');
            if (data.LevelID().toString().includes('OVERALL')) {
                AIWViewModel.WeightingsType('BULOverall');

                GetBUlevelOverallWeightings();
                if (AIWViewModel.LastClickedLevelDetailId() == 'LevelOverall') {
                    var id = document.getElementById('AMLTabDiv-' + AIWViewModel.LastClickedLevelDetailId());
                    if (id != null && id != undefined && id != '') {
                        document.getElementById('AMLTabDiv-' + AIWViewModel.LastClickedLevelDetailId()).innerHTML = "";
                    }
                    for (var i = 0; i < AIWViewModel.RiskAreaList().length; i++) {
                        document.getElementById('AMLTabDiv-' + AIWViewModel.RiskAreaList()[i].RiskAreaId()).innerHTML = "";
                    }
                    var idRA = document.getElementById('AMLTabDiv-' + AIWViewModel.RAId());
                    if (idRA != null && idRA != undefined && idRA != '') {
                        document.getElementById('AMLTabDiv-' + AIWViewModel.RAId()).innerHTML = "";
                        $('#AMLTabDiv-' + AIWViewModel.RAId()).hide();
                    }
                }
                AIWViewModel.LastClickedLevelDetailId(AIWViewModel.ClickedLevelDetailId());
                var id = document.getElementById('AMLTabDiv-' + AIWViewModel.LastClickedLevelDetailId());
                if (id != null && id != undefined && id != '') {
                    document.getElementById('AMLTabDiv-' + AIWViewModel.LastClickedLevelDetailId()).innerHTML = "";
                }
            }
            else {
                getAllBusinessUnitlowestLevels(data.DetailId());
            }
            addNewDivTabBULevel(data.LevelID());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BusinessLevelDetailTabClick() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in AMLInherentWeightings.js';
            logger.logMessage(msg);
        }
    }
    //-----------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------

});
